<template>
    <div v-if="topic.zhidaoyu && zhidaoyuDjs"  style="font-size: 30px;width: 100%;" class="terminal-bg-zdy">
        <div class="zdyText">指导语</div>
        <div class="flex flex-child-center" style="margin: 200px auto;width: 1200px">
            <div style="width: 18px;height: 18px;background: #7DB167;border-radius: 50%;margin-right: 20px;"></div>
            <div style="width: 1150px;">{{ topic.zhidaoyu }}</div>
        </div>
        <div class="flex flex-justify-content-center">
            <div class="button-wrap-zdy">
                <!--                <div style="margin-bottom: 30px;color: #2FB2FB;font-size: 36px;font-weight: bold;">-->
                <!--                    <span>{{ zhidaoyuDjs }}s后自动关闭</span>-->
                <!--                </div>-->
                <div class="submit-question prev3" @click="exam_end">
                    <span>确定</span>
                    <img src="../assets/images/submit.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="huaban" v-else-if="topic.type === 69 && huaban">
        <div class="content_">
            <div class="container">
                <div class="row">
                    <div style="font-size: 24px;line-height: 30px;width: 400px;padding: 20px;color: #ffffff;font-weight: bold'">
                       {{ topic.intro }}
                    </div>
                    <div>
                        <img :src="topic.title_img">
                    </div>
                    <ul name="" class="type">
                        <li :class="{'typeactive':item.type===type}" @click="clicType(item)"
                            v-for="(item,index) in typeList" :key="index">
                            <span v-html="item.name"></span>
                        </li>
                    </ul>
                    <div class="space"></div>
                    <div class="box"><span>颜色</span><input type="color" v-model="color"></div>
                    <div class="box"><span>粗细</span><input type="number" name="number" v-model="linewidth" max="150" min="1"></div>
                    <div class="space"></div>
                    <input class="xinjian_width" type="hidden" max="700" min="500" value="500">
                    <input class="xinjian_height" type="hidden" max="648" min="300" value="300">
                    <input style="display: none;" type="button" name="queding" value="确定" id="ding">
                    <div class="clear shezhi" @click="clickClear">清&nbsp;&nbsp;&nbsp;空</div>
                    <div class="back shezhi" @click="clickRevoke">撤&nbsp;&nbsp;&nbsp;销</div>
                </div>
                <div class="save shezhi" @click="clickGetImg">生成图片</div>
            </div>
            <canvas class="canvas-box" id="canvasBox" @mousedown="mousedown"  @touchstart="mousedown"></canvas>
        </div>
    </div>
    <div class="terminal-bg" v-else>
        <div class="sheet">
            <div class="typeface">
                <img src="../assets/images/zijiada.png" @click="sizeBig">
                <img src="../assets/images/zijianxiao.png" @click="sizeSmall">
            </div>
<!--            <div class="timer" v-if="time_show">-->
<!--                <img src="../assets/images/shijian.png">-->
<!--                <span>{{ hourString + ':' + minuteString + ':' + secondString }}</span>-->
<!--            </div>-->
            <div class="page-count">{{ topic.now_count }} <span>/{{ topic.all_count }}</span></div>

            <div style="width: 100%;">
                <div class="title" id="title" style="font-size: 40px;margin: 0 auto;text-align: center;margin-top: 300px;" v-if="topic.title_img ==''  && topic.type == 59 || topic.type === 60 && topic.title_img ==''|| topic.type === 55 && topic.title_img ==''">
                    <h3 v-html="topic.intro">
                    </h3>
                </div>
                <div class="title" id="title" style="font-size: 24px" v-else>
                    <h3 v-html="topic.intro">
                    </h3>
                </div>
<!--                <div class="title"style="font-size: 16px" v-if="topic.type !== 54">-->
<!--                    <div v-html="topic.title_text">-->
<!--                    </div>-->
<!--                </div>-->
                <div class="options-wrap">
                    <div class="options-list">
                        <!--                        选择-->
                        <template v-if="topic.type === 60 ">
                            <div style="height: 202px;margin-bottom: 50px;"  v-if="topic.title_img">
                                <img :src=" topic.title_img" alt="" class="options-img-judgment_answer">
                            </div>
<!--                            <el-radio-group v-model="options"-->
<!--                                            @change="answer"-->
<!--                                            :class="(topic.answer || '').length > 4 ? 'radio-wrap' : ''"-->
<!--                                            id="radio" style="font-size: 20px">-->
<!--                                <el-radio :label="item.id"-->
<!--                                          v-for="item in topic.answer"-->
<!--                                          :key="item.id"-->
<!--                                          :class="(topic.answer || '').length > 4 ? 'radio' : ''"-->
<!--                                >-->
<!--                                    {{ item.text }}-->
<!--                                </el-radio>-->
<!--                            </el-radio-group>-->
                        </template>
                        <!--                        数方块-->
                        <template v-if="topic.type === 57">
                            <div style="margin-bottom: 100px;margin-top: 200px;"  v-if="topic.title_img">
                                <img :src=" topic.title_img" alt="" style="display:block;margin: 0 auto; width: 1200px;">
                            </div>
<!--                            <el-radio-group v-model="options"-->
<!--                                            @change="answer"-->
<!--                                            :class="(topic.answer || '').length > 4 ? 'radio-wrap' : ''"-->
<!--                                            id="radio" style="font-size: 20px">-->
<!--                                <el-radio :label="item.id"-->
<!--                                          v-for="item in topic.answer"-->
<!--                                          :key="item.id"-->
<!--                                          :class="(topic.answer || '').length > 4 ? 'radio' : ''"-->
<!--                                >-->
<!--                                    {{ item.text }}-->
<!--                                </el-radio>-->
<!--                            </el-radio-group>-->
                        </template>
                        <!--                        59判断    55数字广度-->
                        <template v-if="topic.type === 59|| topic.type === 55">
                            <div class="options-judgment-box">
                                <div style="">
                                    <img :src=" topic.title_img" alt="" class="options-img-judgment" v-if="topic.title_img">
                                </div>
<!--                                <div class="options-judgment-box-answer" style="width: 60%;" :style="topic.title_img ? 'margin-top:100px' : 'margin-top:0'">-->
<!--                                    <div v-for="(item,index) in topic.answer" :key="index" style="cursor: pointer;position: relative;" @click="answerJudgment(item.id)">-->
<!--                                        <img src="../assets/images/answerQuestions.png" v-if="options == item.id" class="answerQuestions_image">-->
<!--                                        <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img">-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                        </template>
                        <!--                        62图片词汇    66算数-->
                        <template v-if="topic.type === 62|| topic.type === 66">
                            <div class="options-judgment-box" style="margin-bottom: 50px;">
                                <div class="options-judgment-box-answer" style="width: 90%;margin-top: 120px;">
<!--                                    <div v-for="(item,index) in topic.answer" :key="index" style="cursor: pointer;position: relative;" @click="answerJudgment(item.id)">-->
<!--                                        <img src="../assets/images/answerQuestions.png" v-if="options_50 == item.id" class="answerQuestions_image">-->
<!--                                        <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img" style="height: 202px;">-->
<!--                                    </div>-->
                                    <div v-for="(item,index) in topic.answer" :key="index" style="cursor: pointer;position: relative;">
<!--                                        <img src="../assets/images/answerQuestions.png" v-if="options_50 == item.id" class="answerQuestions_image">-->
                                        <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img" style="height: 202px;">
                                    </div>
                                </div>
                            </div>
<!--                            <el-radio-group-->
<!--                                v-if="answerList.length>0"-->
<!--                                v-model="options"-->
<!--                                @change="answer50"-->
<!--                                :class="(topic.answer || '').length > 4 ? 'radio-wrap' : ''"-->
<!--                                id="radio" style="font-size: 20px">-->
<!--                                <el-radio :label="item.id"-->
<!--                                          v-for="item in answerList"-->
<!--                                          :key="item.id"-->
<!--                                          :class="(answerList || '').length > 4 ? 'radio' : ''"-->
<!--                                >-->
<!--                                    {{ item.text }}-->
<!--                                </el-radio>-->
<!--                            </el-radio-group>-->
                        </template>
                        <!--                        64图片概括-->
                        <template v-if="topic.type === 64">
                            <div class="options-judgment-box flex">
                                <div style="width: 1600px;">
                                    <div style="height: 202px;">
                                        <img :src=" topic.title_img" alt="" class="options-img-judgment" v-if="topic.title_img" style="height: 202px;">
                                    </div>
                                    <div class="options-judgment-box-answer" style="width: 90%; margin-top: 50px;">
                                        <div v-for="(item,index) in topic.answer" :key="index" style="cursor: pointer;position: relative;">
                                            <img src="../assets/images/answerQuestions.png" v-if="options_50 == item.id" class="answerQuestions_image" style="height: 202px;">
                                            <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img" style="height: 202px;margin: 50px auto;">
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </template>
                        <!--                        图片排列   视觉分析-->
                        <template v-if="topic.type == 65">
                            <div class="options-judgment-box" style="margin-bottom: 50px;margin-top: 30px;">
                                <div class="options-judgment-box-answer" style="width: 90%;">
                                    <!--                                    <div v-for="(item,index) in image_list51" :key="index" style="cursor: pointer;position: relative;" @click="answerJudgment(item)">-->
                                    <!--                                        <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img && item.num!==0">-->
                                    <!--                                        <div class="image_box_none" v-else></div>-->
                                    <!--                                    </div>-->
                                    <VueDragResize
                                        v-for="(item,index) in image_list51" :key="index"
                                        ref="imgDrag"
                                        :isActive="true"
                                        :isResizable="false"
                                        :isDraggable="true"
                                        :parentLimitation="true"
                                        :parentW="1920"
                                        :parentH="1080"
                                        :x="item.rights"
                                        :y="item.tops"
                                        :z="999"
                                        :w="333"
                                        :h="202"
                                        v-on:dragging="onDragging($event,index)"
                                        v-on:dragstop="onDragstop($event,index)"
                                    >
                                        <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img && item.num!==0" style="z-index: 999;height: 202px;margin: 0;">
                                    </VueDragResize>
                                </div>
                            </div>
                            <div class="options-judgment-box" style="">
                                <div class="options-judgment-box-answer" style="width: 90%;">
                                    <div v-for="(item,index) in image_list51_answer" :key="index" style="position: fixed;" :style="[{ 'top': item.top + 'px'},{'left':item.right+'px'}]">
                                        <img :src=" item.image"  alt="" class="options-img-judgment" v-if="item.image !==''" style="height: 202px;margin: 0;">
                                        <img :src=" item.img"  alt="" class="options-img-judgment" v-else style="height: 202px;margin: 0;">
                                    </div>
                                </div>
                            </div>
<!--                            <div class="option_button" style="position: fixed;bottom: 150px;right: 50px;">-->
<!--                                <div class="prev" @click="rearrange(51)">-->
<!--                                    <span>重新排列</span>-->
<!--                                </div>-->
<!--                                <div class="prev" @click="permutation">-->
<!--                                    <span>确定排列</span>-->
<!--                                </div>-->
<!--                            </div>-->
                        </template>
                        <!--                        木块图-->
                        <template v-if="topic.type === 68">
                            <div class="topic_53_box" style="width: 100%;height: 100%;" >
                                <div >
                                    <div v-for="(item, index) in image_list53" :key="index"
                                         class="image-wrapper"
                                         :style="{transform: 'translate3d(' + item.rights + 'px, ' + item.tops+ 'px, 0) rotate(' + item.rotation + 'deg)'}"
                                         ref="img"
                                    >
                                        <img :src=" item.img" alt="" class="drag-image" @contextmenu.prevent>
                                    </div>
                                </div>
                                <img :src=" topic.title_img" class="image_53_back" style="z-index: 100">
                            </div>
                        </template>
                        <!--                        图形拼凑-->
                        <template v-if="topic.type === 58">
                            <div class="topic_53_box" style="width: 100%;height: 100%;touch-action: none">
                                <div v-for="(item, index) in image_list53" :key="index"
                                     class="image-wrapper"
                                     :style="{transform: 'translate3d(' + item.rights + 'px, ' + item.tops+ 'px, 0) rotate(' + item.rotation + 'deg)'}"
                                     ref="img"
                                >
                                    <img :src=" item.img" alt="" class="drag-image" @contextmenu.prevent>
                                </div>
                                <div>
                                    <img :src=" topic.title_img"
                                         ref="hammerTest"
                                         class="image_53_back"
                                         style="z-index: 100;right: 450px;display: block;"
                                    >
                                </div>
                                <div class="type58Box">
                                    <div>
                                        <el-radio-group v-model="type58id"
                                                        @change="answer58"
                                                        :class="(answerList58 || '').length > 4 ? 'radio-wrap' : ''"
                                                        id="radio" style="font-size: 20px"
                                        >
                                            <el-radio :label="item.id"
                                                      v-for="item in answerList58"
                                                      :key="item.id"
                                                      :class="(answerList58 || '').length > 4 ? 'radio' : ''"
                                            >
                                                {{ item.text }}
                                            </el-radio>
                                        </el-radio-group>
                                        <el-radio-group
                                            v-if="type58id == 2"
                                            v-model="score58id"
                                            @change="score58answer"
                                            :class="(scoreList || '').length > 4 ? 'radio-wrap' : ''"
                                            id="radio" style="font-size: 20px"
                                        >
                                            <el-radio :label="item.id"
                                                      v-for="item in scoreList"
                                                      :key="item.id"
                                                      :class="(scoreList || '').length > 4 ? 'radio' : ''"
                                            >
                                                {{ item.text }}
                                            </el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="option_button">
                                </div>
                            </div>
                        </template>
                        <!--                        翻方块-->
                        <template v-if="topic.type === 52">
                            <div class="flex">
                                <div class="options52_box">
                                    <div v-for="(item,index) in image_list52" :key="index"
                                         style="cursor: pointer;position: relative;" @click="answerJudgment(item.num)" class="options52_box_child"
                                         :style="{'background': item.color}" >
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!--                        编码测验-->
                        <template v-if="topic.type === 61">
                            <div style="">
                                <img :src=" topic.title_img" alt="" class="options-img-judgment" style="height: 160px;margin: 0 auto;display: block;">
                            </div>
                            <div class="flex flex-justify-content-center" style="margin-top: 40px;font-size: 0!important;padding-left: 42px;position: relative">
                                <div v-for="(item,index) in topic.answer" :key="index" >
                                    <img :src=" item.img" alt="" class="options-img-judgment" style="width: 80px;height: 78px;margin-right: 42px;">
                                    <div v-for="(item1,index1) in item.child" :key="index1" style="cursor: pointer;position: relative;" @click="typeClick(index,index1)">
                                        <img v-if="item1.show" :src=" item1.mp3" alt="" class="options-img-judgment" style="width: 80px;height: 78px;margin-right: 42px;">
                                        <img v-else="item1.show" :src=" item1.img" alt="" class="options-img-judgment" style="width: 80px;height: 78px;margin-right: 42px;">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!--                        多选-->
                        <template v-if="topic.type === 67">
                            <div class="options-judgment-box" style="margin-bottom: 50px;">
                                <div class="options-judgment-box-answer" style="width: 90%;margin-top: 120px;">
                                    <div v-for="(item,index) in topic.answer" :key="index" style="cursor: pointer;position: relative;" @click="answerJudgment(item,index)">
                                        <img src="../assets/images/answerQuestions.png" v-if="item.isshow == true" class="answerQuestions_image" style="width: 333px;
        height: 201px;">
                                        <img :src=" item.img" alt="" class="options-img-judgment" v-if="item.img" style="width: 333px;
        height: 201px;">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!--                        迷津-->
                        <template v-if="topic.type ===63">
                            <div>
                                <img :src=" topic.title_img1" alt="迷宫图片" id="mazeImg" class="maze-img">
                                <canvas ref="mazeCanvas"
                                        id="canvasBox" class="maze-canvas"
                                        @mousedown="startDrawing"
                                        @mousemove="drawLine"
                                        @mouseup="endDrawing"
                                        @touchstart="startDrawing"
                                        @touchmove="drawLine"
                                        @touchend="endDrawing"
                                >

                                </canvas>
                            </div>
                        </template>
                    </div>
                    <img :src="topic.image" alt="" class="options-img" v-if="topic.image">
                </div>
                <div class="flex flex-justify-content-center button-wrap">
                    <div class="flex">
<!--                        <div class="prev prev5"  @click="choiceSubmit" v-if="topic.type === 67">-->
<!--                            <span>确定</span>-->
<!--                        </div>-->
                        <div class="prev prev5" @click="submit054" v-if="topic.type === 61">
                            <span>确定</span>
                        </div>
                        <div class="prev prev2"  @click="rearrange(65)" v-if="topic.type === 65">
                            <span>重新摆放</span>
                        </div>
                        <div class="prev prev3"  style="margin-left: 70px;" @click="permutation" v-if="topic.type === 65">
                            <span>确定摆放</span>
                        </div>
                        <div class="prev prev2"  @click="clickClearMg" v-if="topic.type === 63">
                            <span>重新绘图</span>
                        </div>
                        <div class="prev prev3"  style="margin-left: 70px;" @click="generate" v-if="topic.type === 63">
                            <span>生成图片</span>
                        </div>
                        <!--                    <div class="prev prev1" @click="readTopic">-->
                        <!--                        <img src="../assets/images/language.png" alt="">-->
                        <!--                        <span>重复语言</span>-->
                        <!--                    </div>-->
                        <!--                    <div class="prev prev2" style="margin-left: 70px;" @click="prevTopic">-->
                        <!--                        <img src="../assets/images/prev.png" alt="">-->
                        <!--                        <span>上一题</span>-->
                        <!--                    </div>-->
                        <!--                    <div class="prev prev3" style="margin-left: 70px;" @click="nextTopic">-->
                        <!--                        <span>下一题</span>-->
                        <!--                        <img src="../assets/images/next.png" alt="">-->
                        <!--                    </div>-->
                        <!--                    <el-button class="skip-question" @click="nextTopic">-->
                        <!--                        <span>跳过</span>-->
                        <!--                        <img src="../assets/images/skip.png" alt="">-->
                        <!--                    </el-button>-->
                        <!--                    <div class="prev prev4" style="margin-left: 70px;" @click="endExam">-->
                        <!--                        <span>结 束</span>-->
                        <!--                        <img src="../assets/images/submit.png" alt="">-->
                        <!--                    </div>-->
                    </div>
                </div>

            </div>
        </div>
        <el-dialog class="new-dialog text-dialog" :visible.sync="dialogChuan"  width="20%" :close-on-click-modal="false" :show-close="false">
            <div>
                <div><img style="margin:0 auto; display: block; " src="../assets/images/timer.png"></div>
                <div style="margin-top: 20px; font-size: 24px; color: #333333; line-height: 31px; ">时间超时，停止作答!</div>
            </div>
        </el-dialog>
    </div>
</template>
<script src="https://cdn.bootcdn.net/ajax/libs/hammer.js/2.0.8/hammer.min.js">
</script>
<script>
import $ from 'jquery'
//import { defineComponent, reactive, onMounted, onUnmounted, getCurrentInstance } from 'vue'

//const global = require("/src/plugs/ipcRenderer");
/*const state = reactive({
    open: true,
    message: ''
})*/
import VueDragResize from "vue-drag-resize";
import Vue from "vue"
import { drag } from "../plugs/scale";
// import Hammer from 'hammerjs';
import {
    Draw
} from '../utils/huaban'
let x, y, w, h;
let lx, ly, lw, lh;
let cutdata;
export default {
    name: "TerminalAnswerScreen",
    components: {
        VueDragResize
    },
    data() {
        return {
            state:{
                open:true,
                message: ''
            },
            options: '',
            topic: {},
            titleVoice: '',
            answerVoice: '',
            gap_filling: [],
            gap: '',
            hour: '',
            minute: '',
            second: '',
            promiseTimer: '',
            time_show: false,
            answerList:[],
            options_50:'',
            image_list51:[],
            image_list51_answer:[],
            num:0,
            image_list52:[],
            image_list53:[],
            // image_list53_answer:[],
            // right:'',
            // top:'',
            zhidaoyuDjs:false,
            // timerzdy:null,
            answerList58:[
                {
                    text:'正确',
                    id:1
                },
                {
                    text:'错误',
                    id:2
                }
            ],
            type58id:'',
            scoreList:[
                {
                    id:0,
                    text:'A.0分'
                },
                {
                    id:1,
                    text:'B.1分'
                },
                {
                    id:2,
                    text:'C.2分'
                },
                {
                    id:3,
                    text:'D.3分'
                },
                {
                    id:4,
                    text:'E.4分'
                },
                {
                    id:5,
                    text:'F.5分'
                },
            ],
            score58id:'',
            zhidaoyuVoice:'',
            rotate: 0,
            transform:'',
            permutationNum:0,
            websock: null,
            sendData:'',
            exam_id:'',
            patient_id:'',
            mcList: [], // 存储Hammer.js管理器的数组
            startRotation:0,
            DragResize:true,
            updateImmediate:null,
            answerId65:'',
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            canvas: null,
            ctx: {},
            scoreList63:[],
            canvasBox: null,
            canvasObj: null,
            width: 0,
            height: 0,
            type: 'pen', // 画笔类型
            typeList: [ // 画笔类型列表
                {
                    name: '铅&nbsp;&nbsp;&nbsp;笔',
                    type: 'pen'
                },
                {
                    name: '橡&nbsp;&nbsp;&nbsp;皮',
                    type: 'eraser'
                },
            ],
            n: 3, // 多边形变数
            color: '#000000', // 颜色
            linewidth: 1, // 线宽
            style: 'stroke', // 填充样式
            arr: [], // 绘制的数组
            cutflag: false,
            iscut:true,
            dialogChuan:false,
            isQuestion:true,
            timerWeb:null,
            screenQ_id:'',
            isExamjs:false

        };
    },
    props: {
        // 倒计时间总秒数
        remainTime: {
            default: '1800'
        }
    },
    computed: {
        hourString() {
            return this.formatNum(this.hour)
        },
        minuteString() {
            return this.formatNum(this.minute)
        },
        secondString() {
            return this.formatNum(this.second)
        },
    },
    watch: {
        exam_id(newValue, oldValue) {
            // console.log(newValue,oldValue)
            this.getTopic();
            // if(!this.zhidaoyuDjs) {
            //     this.readTopic();
            // }
        }
    },
    beforeDestroy() {
        this.mcList.forEach((mc) => {
            mc.destroy();
        });
        this.clearTimerWeb()
    },
    async mounted() {
        this.init()
        // console.log('3333333333',this.$store.state.token,this.$route.query)
        // if (this.remainTime > 0) {
        //     this.hour = Math.floor((this.remainTime / 3600) % 24)
        //     this.minute = Math.floor((this.remainTime / 60) % 60)
        //     this.second = Math.floor(this.remainTime % 60)
        //     this.countDowm()
        // }

    },
    methods: {
        clickClearMg() {
            this.isDrawing= false
            this.lastX = 0
            this.lastY = 0
            this.canvas = null
            this.ctx = null
            setTimeout(() => {
                const canvasBox = document.getElementById('canvasBox')
                const mazeImg = document.getElementById('mazeImg')
                canvasBox.width = mazeImg.width
                canvasBox.height = mazeImg.height
                this.canvas = canvasBox
                // console.log('canvasBox',canvasBox)
                this.ctx = canvasBox.getContext('2d')
            },200)
        },
        startDrawing(e) {
            // console.log('e',e)
            this.isDrawing = true
            if (e.type === 'mousedown') {
                this.lastX = e.offsetX
                this.lastY = e.offsetY
            } else if (e.type === 'touchstart') {
                this.lastX = e.touches[0].clientX - this.canvas.getBoundingClientRect().left
                this.lastY = e.touches[0].clientY - this.canvas.getBoundingClientRect().top
            }
        },
        drawLine(e) {
            if (!this.isDrawing) return
            e.preventDefault()
            if (e.type === 'mousemove') {
                this.ctx.beginPath()
                this.ctx.moveTo(this.lastX, this.lastY)
                this.ctx.lineTo(e.offsetX, e.offsetY)
                this.ctx.lineWidth = 10 // 线条宽度
                this.ctx.strokeStyle = "#F6B05D" //线样式
                this.ctx.stroke()
                this.lastX = e.offsetX
                this.lastY = e.offsetY
            } else if (e.type === 'touchmove') {
                this.ctx.beginPath()
                this.ctx.moveTo(this.lastX, this.lastY)
                this.ctx.lineTo(e.touches[0].clientX - this.canvas.getBoundingClientRect().left, e.touches[0].clientY - this.canvas.getBoundingClientRect().top)
                this.ctx.lineWidth = 10 // 线条宽度
                this.ctx.strokeStyle = "#F6B05D" //线样式
                this.ctx.stroke()
                this.lastX = e.touches[0].clientX - this.canvas.getBoundingClientRect().left
                this.lastY = e.touches[0].clientY - this.canvas.getBoundingClientRect().top
            }
            // console.log('this.ctx',this.ctx,typeof (this.ctx))
            // let answerJson = {
            //     lastY:this.lastY,
            //     lastX:this.lastX,
            //     ctx:this.ctx,
            // }
            // console.log('answerJson',answerJson)
            // console.log('this.ctx',this.ctx)
            // this.$axios.post('api/zipreport/maze', this.$qs.stringify({
            //     exam_id:this.exam_id,
            //     lastY:this.lastY,
            //     lastX:this.lastX,
            //     ctx:this.ctx,
            // })).then(res => {
            //
            // })
            // this.websocketsend('1000'+this.sendData+'@'+'mijing');



        },
        endDrawing() {
            this.isDrawing = false
        },
        initCanvas() {
            const canvasBox = document.getElementById('canvasBox')
            this.canvasBox = canvasBox;
            this.canvasObj = canvasBox.getContext("2d");
            const screenWidth = document.documentElement.clientWidth;
            const screenHeight = document.documentElement.clientHeight;
            this.width = screenWidth - 290;
            this.height = screenHeight - 40;
            canvasBox.width=this.width;
            canvasBox.height=this.height;
        },
        // 点击画笔类型
        clicType(item) {
            this.type = item.type
            if (item.type === 'pen' || item.type === 'line') {
                this.style = 'stroke'
            }
        },
        // 点击样式
        clickStyle(style) {
            this.style = style
        },
        // 点击清空
        clickClear() {
            this.arr = [];
            this.canvasObj.clearRect(0, 0, this.width, this.height);
        },
        // 点击撤销
        clickRevoke() {
            this.arr.pop();
            this.canvasObj.clearRect(0, 0, this.width, this.height);
            if (this.arr.length > 0) {
                this.canvasObj.putImageData(this.arr[this.arr.length - 1], 0, 0, 0, 0, this.width, this.height);
            }
        },
        // 开始绘画
        mousedown(option) {
            // console.log('e',e)
            if (option.type === 'mousedown') {
                x = option.offsetX;
                y = option.offsetY;
                if (this.type == "pen") {
                    // console.log(x,y)
                    this.canvasObj.beginPath();
                    this.canvasObj.moveTo(x, y);
                }
                if (this.type == "eraser") {
                    this.canvasObj.clearRect(x - 5, y - 5, 10, 10);
                }
                if (this.cutflag && this.type == "cut") {
                    if (this.arr.length != 0) {
                        this.arr.splice(-1, 1);
                    }
                }
                var draw = new Draw(this.canvasObj, {
                    type: this.style,
                    color: this.color,
                    width: this.linewidth
                }); //实例化构造函数
                this.canvasBox.onmousemove = (e) => {
                    // console.log('eeee',e)
                    w = e.offsetX;
                    h = e.offsetY;
                    if (this.type != "eraser") {
                        this.canvasObj.clearRect(0, 0, this.width, this.height);
                        if (this.arr.length != 0) {
                            this.canvasObj.putImageData(this.arr[this.arr.length - 1], 0, 0, 0, 0, this.width, this.height);
                        }
                    }
                    if (this.cutflag && this.type == "cut") {
                        if (this.iscut) {
                            this.canvasObj.clearRect(lx, ly, lw - lx, lh - ly);
                        }
                        var nx = lx + (w - x);
                        var ny = ly + (h - y);
                        this.canvasObj.putImageData(cutdata, nx, ny);
                    }
                        // else if (this.type == "poly") {
                        //   draw[this.type](x, y, w, h, this.n);
                    // }
                    else {
                        draw[this.type](x, y, w, h);
                    }
                }
                document.onmouseup = () => {
                    // console.log('222')
                    this.canvasBox.onmousemove = null;
                    document.onmouseup = null;
                    if (this.type == "cut") {
                        if (!this.cutflag) {
                            this.cutflag = true;
                            cutdata = this.canvasObj.getImageData(x + 1, y + 1, w - x - 2, h - y - 2);
                            lx = x;
                            ly = y;
                            lw = w;
                            lh = h;
                        } else {
                            this.cutflag = false;
                        }
                    }
                    this.arr.push(this.canvasObj.getImageData(0, 0, this.width, this.height));
                }
            } else if (option.type === 'touchstart') {
                x = option.touches[0].clientX - this.canvasBox.getBoundingClientRect().left
                y = option.touches[0].clientY - this.canvasBox.getBoundingClientRect().top
                if (this.type == "pen") {
                    this.canvasObj.beginPath();
                    this.canvasObj.moveTo(x, y);
                }
                if (this.type == "eraser") {
                    this.canvasObj.clearRect(x - 5, y - 5, 10, 10);
                }
                if (this.cutflag && this.type == "cut") {
                    if (this.arr.length != 0) {
                        this.arr.splice(-1, 1);
                    }
                }
                var draw = new Draw(this.canvasObj, {
                    type: this.style,
                    color: this.color,
                    width: this.linewidth
                }); //实例化构造函数
                this.canvasBox.addEventListener('touchmove', (e) => {
                    w = e.touches[0].clientX - this.canvasBox.getBoundingClientRect().left
                    h = e.touches[0].clientY - this.canvasBox.getBoundingClientRect().top
                    if (this.type != "eraser") {
                        this.canvasObj.clearRect(0, 0, this.width, this.height);
                        if (this.arr.length != 0) {
                            this.canvasObj.putImageData(this.arr[this.arr.length - 1], 0, 0, 0, 0, this.width, this.height);
                        }
                    }
                    if (this.cutflag && this.type == "cut") {
                        if (this.iscut) {
                            this.canvasObj.clearRect(lx, ly, lw - lx, lh - ly);
                        }
                        var nx = lx + (w - x);
                        var ny = ly + (h - y);
                        this.canvasObj.putImageData(cutdata, nx, ny);
                    }
                    else {
                        draw[this.type](x, y, w, h);
                    }
                });
                document.addEventListener('touchend', () => {
                    this.canvasBox. null;
                    document. null;
                    if (this.type == "cut") {
                        if (!this.cutflag) {
                            this.cutflag = true;
                            cutdata = this.canvasObj.getImageData(x + 1, y + 1, w - x - 2, h - y - 2);
                            lx = x;
                            ly = y;
                            lw = w;
                            lh = h;
                        } else {
                            this.cutflag = false;
                        }
                    }
                    this.arr.push(this.canvasObj.getImageData(0, 0, this.width, this.height));
                });
            }
        },
        // 获取图片
        clickGetImg(){
            const src = this.canvasBox.toDataURL("image/png");//跳转页面手动保存
            this.$axios.post('api/upload/upload_base64_img', {
                img:src,
                exam_id:this.exam_id
            }).then(res => {
                if (res.data.code == 1) {
                    this.websocketsend('2000'+this.sendData+'@'+'tuxing'+res.data.data);

                    // this.$router.push({
                    //     name: 'TerminalDrawingBoard',
                    //     query: {
                    //         img:src,
                    //         exam_id: this.$route.query.id,
                    //         test_paper_id: this.$route.query.test_paper_id
                    //     }
                    // });
                }
            })
            // this.downLoad(src)
        },
        //生成图片（迷宫）
        generate() {
            if(!this.isQuestion) {
                this.$message.error('当前主副屏未同步，请稍后进行作答!')
                let answerJson = {
                    id:this.topic.id,
                }
                this.websocketsend('2000'+this.sendData+'@'+'tongBu'+JSON.stringify(answerJson))
                return
            }
            const src = this.canvas.toDataURL("image/png");//跳转页面手动保存
            this.$axios.post('api/upload/upload_base64_img', {
                img:src,
                exam_id:this.exam_id
            }).then(res => {
                if (res.data.code == 1) {
                    this.websocketsend('2000'+this.sendData+'@'+'mijing'+res.data.data);

                    // this.$router.push({
                    //     name: 'TerminalDrawingBoard',
                    //     query: {
                    //         img:src,
                    //         exam_id: this.$route.query.id,
                    //         test_paper_id: this.$route.query.test_paper_id
                    //     }
                    // });
                }
            })
        },
        downLoad(url){
            var oA = document.createElement("a");
            oA.download = '画布.png';// 设置下载的文件名，默认是'下载'
            oA.href = url;
            document.body.appendChild(oA);
            oA.click();
            oA.remove(); // 下载之后把创建的元素删除
        },
        init() {
            let url = 'ws://59.110.67.66:8304'
            console.log('副屏url',url)
            this.websock = new WebSocket(url)
            // 监听打开
            this.websock.onopen= this.websockOpen;
            // 监听关闭
            this.websock.onclose = this.websockClose;
            //监听异常
            this.websock.onerror = this.websockError;
            //监听服务器发送的消息
            this.websock.onmessage = this.websockMessage;
            // console.log('this.websock副屏',this.websock)
        },
        //连接建立之后执行send方法发送数据
        websockOpen() {
            // console.log('监听打开（副屏）')
            this.websocketsend('2002');
            this.websockTimer()
            // this.websocketsend('111111111111');
        },
        //实时发送
        websockTimer() {
            this.timerWeb = setInterval(() =>{
                this.websocketsend('heartbeat2');
            },10000)
        },
        //清除实时发送
        clearTimerWeb() {
            clearInterval(this.timerWeb)
            this.timerWeb = null
        },
        //关闭
        websockClose() {
            // console.log('主屏监听关闭')
            // 关闭当前连接
            this.websock.close();
            // 重新连接
            setTimeout(() => {
                this.init()
            }, 3000); // 3秒延迟后重新连接
        },
        //连接建立失败重连
        websockError() {
            // console.log('主屏监听异常')
            // 关闭当前连接
            this.websock.close();
            // 重新连接
            setTimeout(() => {
                this.init()
            }, 3000); // 3秒延迟后重新连接
        },
        //数据接收
        websockMessage(e) {
            // console.log('监听服务器结收的消息（副屏）',e.data)
            let a = e.data.substr(0,4)
            if(a == 2001) {
                let b = e.data.slice(4)
                let length = b.length
                let token = b.substring(0,length-2)
                let hukou = b.substr(-1)
                // this.clearTimerWeb()
                this.websocketsend('2001'+b);
                // setTimeout(() => {
                //
                //     setTimeout(() => {
                //         this.websockTimer()
                //     },2000)
                // },1000)

                this.$store.commit('setToken', token)
                this.$store.commit('setHukou', hukou)
                // console.log('111111111111111111111111111111111111')
                // this.websocketsend('1000'+this.sendData+'@'+
                //     'parent'+JSON.stringify(''));
                // if(!this.zhidaoyuDjs) {
                //     this.readTopic();
                // }
            }
            // if(a == 3000) {
            //    this.init()
            // }
            if(a == 'wena') {
                this.sendData =  e.data.slice(4)
                this.websocketsend('2000'+this.sendData+'@'+'online');
            }
            if(a == 'yuab') {
                let result = e.data.slice(4)
                if (result.length == 10) {
                    //选择题选中   确定按钮点击
                    // if(result == 'answer_end') {
                    //     // this.showTitle = true
                    //     this.dialogChuan = false
                    //     if(this.topic.type == 69) {
                    //         this.huaban = false
                    //         this.clickClear()
                    //     }
                    //     this.answer_end()
                    // }
                    // if(result == 'prev_topic') {
                    //     // this.showTitle = true
                    //     this.dialogChuan = false
                    //     this.prevTopic()
                    // }
                    // if(result == 'next_topic') {
                    //     // this.showTitle = true
                    //     this.dialogChuan = false
                    //     this.nextTopic()
                    // }
                    if(result == 'read_Topic') {
                        this.readTopic()
                    }
                    if(result == 'endEndExam') {
                        this.clearTimerWeb()
                        window.speechSynthesis.cancel()
                        this.$router.push(
                            {
                                name: 'TerminalEnd',
                                query: {
                                    exam_id: this.exam_id,
                                    patient_id:this.patient_id,
                                }
                            }
                        )
                    }
                } else {
                    let identification = result.substr(0,6)
                    // console.log('副屏identification',identification)
                    if (identification == 'examid') {
                        let content = result.slice(6)
                        this.exam_id = JSON.parse(content).exam_id
                        this.patient_id = JSON.parse(content).patient_id
                    }
                    //编码题型
                    if (identification == 'bianma') {
                        let content = result.slice(6)
                        // console.log('副屏bianma')
                        this.topic.answer = JSON.parse(content)
                        this.$forceUpdate()
                    }
                    // 多选
                    if (identification == 'choice') {
                        let content = result.slice(6)
                        // console.log('副屏bianma')
                        this.topic.answer = JSON.parse(content)
                        this.$forceUpdate()
                    }
                    //
                    if (identification == 'pincou') {
                        this.$nextTick(() => {
                            let content = result.slice(6)
                            this.image_list51 = []
                            this.image_list51_answer = []
                            this.image_list51 = JSON.parse(content).image_list51
                            this.image_list51_answer = JSON.parse(content).image_list51_answer
                            this.answerId65 = JSON.parse(content).answerId65
                            // console.log('this.image_list51',this.image_list51)
                            // console.log('this.image_list51_answer',this.image_list51_answer)
                            this.$forceUpdate()
                        })
                    }
                    // if (identification == 'pincoe') {
                    //     this.$nextTick(() => {
                    //         console.log('副屏JSON.parse(content)',JSON.parse(content))
                    //         this.image_list51 = []
                    //         this.image_list51 = JSON.parse(content).image_list51
                    //         // this.image_list51_answer = JSON.parse(content).image_list51_answer
                    //         this.$forceUpdate()
                    //     })
                    // }
                    if (identification == 'colors') {
                        let content = result.slice(6)
                        this.image_list52 = []
                        this.image_list52 = JSON.parse(content)
                        this.$forceUpdate()
                        // console.log('副屏this.image_list52',this.image_list52)
                    }
                    if (identification == 'mukuai') {
                        this.$nextTick(() => {
                            let content = result.slice(6)
                            this.image_list53 = JSON.parse(content)
                            this.$forceUpdate()
                        })
                    }
                    if (identification == 'examjs') {
                        // this.zhidaoyuDjs = false
                        // this.answer_page('zhidaoyu')
                        this.isExamjs = true
                        console.log('identification == \'examjs\'',this.isExamjs)
                        window.speechSynthesis.cancel();
                    }
                    if (identification == 'mijing') {
                        this.$nextTick(() => {
                            let content = result.slice(6)
                            this.lastY = JSON.parse(content).lastY
                            this.lastX = JSON.parse(content).lastX
                            this.ctx = JSON.parse(content).ctx
                            this.$forceUpdate()
                        })
                    }
                    if (identification == 'isQues') {
                        let content = result.slice(6)
                        let id = JSON.parse(content).id
                        // console.log('11111111isQues',id,this.topic.id)
                        if(id == this.topic.id) {
                            this.isQuestion = true
                            this.screenQ_id = id
                        }
                    }
                    if (identification == 'naxtTi') {
                        let content = result.slice(6)
                        let id = JSON.parse(content).id
                        if(id == this.topic.id) {
                            // console.log('id == this.topic.id',id == this.topic.id,id,this.topic.id)
                            if(this.topic.type == 69) {
                                this.huaban = false
                                this.clickClear()
                            }
                            // this.answer_end()
                            this.dialogChuan = false
                            this.nextTopic('communication')
                        } else {
                            if(this.topic.type == 69) {
                                this.huaban = false
                                this.clickClear()
                            }
                            // console.log('false',id,this.topic.id)
                            this.topic.id = id
                            this.dialogChuan = false
                            // console.log('this.topic.id',this.topic.id)
                            // this.answer_end()
                            this.nextTopic('communication')
                        }

                    }
                    if (identification == 'jieshu') {
                        window.speechSynthesis.cancel()
                        this.$router.push({
                            name: 'TerminalEnd',
                            query: {
                                exam_id: this.exam_id,
                                patient_id:this.patient_id,
                            }
                        })
                        this.clearTimerWeb()
                    }
                    if (identification == 'tongBu') {
                        let content = result.slice(6)
                        let id = JSON.parse(content).id
                        this.topic.id = id
                        this.presentInterface()
                        let answerJson = {
                            id:this.topic.id,
                        }
                        this.websocketsend('2000'+this.sendData+'@'+'isQues'+JSON.stringify(answerJson))
                    }
                    if (identification == 'cateNo') {
                        let content = result.slice(6)
                        let id = JSON.parse(content).id
                        // console.log('id',id)
                        this.topic.id = id
                        this.get_cate_now()
                        let answerJson = {
                            id: this.topic.id,
                        }
                        this.websocketsend('2000' + this.sendData + '@' + 'isQues' + JSON.stringify(answerJson))
                    }
                }
                // console.log('副屏result',result)
            }
        },
        /**
         * 当前题目接口（跳分类）
         * */
        async get_cate_now() {
            let params = {
                exam_id: this.exam_id,
                patient_id: this.patient_id,
                question_id: this.topic.id,
            }
            await this.$axios.post('api/TrainExam/cate_now', params).then(res => {
                this.topic = res.data.data;
                this.options = Number(this.topic.answer_id);
                if (res.data.data.zhidaoyu) {
                    this.zhidaoyuDjs = true
                    this.readTopic(res.data.data.zhidaoyu)
                } else {
                    this.answer_page()
                    // this.readTopic()
                }
            })
        },
        //数据发送
        websocketsend(Data){
            console.log('Data（副屏）发送消息',Data)
            this.websock.send(Data);
        },
        // onTouchStart(index, event) {
        //     // console.log('event',event)
        //     // 阻止事件冒泡
        //     event.stopPropagation();
        // },
        // onTouchMove(index, event) {
        //     // 阻止事件冒泡
        //     event.stopPropagation();
        // },
        // onTouchEnd(index) {
        //     // 处理手势结束事件
        // },
        /**
         * 图片旋转事件
         * */
        rotateChange() {
            function throttle(fn, delay) {
                let last = 0;
                return function (...args) {
                    const now = +new Date();
                    if (now - last >= delay) {
                        fn.apply(this, args);
                        last = now;
                    }
                };
            }
            const images = this.$refs.img;
            this.$nextTick(() => {
                const mcList = [];
                images.forEach((image) => {
                    if(this.topic.type == 58) {
                        // console.log('585858')
                        var mc = new Hammer.Manager(image, {
                            recognizers: [
                                [Hammer.Pan, { direction: Hammer.DIRECTION_ALL }],
                                [Hammer.Rotate, { threshold: 0.1 }],  // 设置旋转角度的最小阈值
                            ],
                            touchAction: 'auto', // 允许页面元素的默认行为
                        });
                    } else if(this.topic.type == 68) {
                        // console.log('535353')
                        var mc = new Hammer.Manager(image, {
                            recognizers: [
                                [Hammer.Pan, { direction: Hammer.DIRECTION_ALL }],
                            ],
                        });
                    }
                    mc.on('panstart', (event) => this.onPan(event));
                    // mc.on('panmove', (event) => this.onPan(event));
                    mc.on('panmove',throttle((event) => this.onPan(event),16))
                    mc.on('panend', (event) => this.onPan(event));
                    if(this.topic.type == 58) {
                        mc.on('rotatestart', (event) => this.onRotate(event));
                        mc.on('rotatemove',throttle((event) => this.onRotate(event),16))
                        // mc.on('rotatemove', (event) => this.onRotate(event));
                        mc.on('rotateend',throttle((event) => {
                            const index = [].indexOf.call(this.$refs.img, event.target.parentNode);
                            if (index < 0 || event.type !== 'rotateend') {
                                return;
                            }
                            this.image_list53[index].startAngle = this.image_list53[index].rotation;
                        },16))
                    }

                    // mc.on('rotateend', (event) => {
                    //     const index = [].indexOf.call(this.$refs.img, event.target.parentNode);
                    //     if (index < 0 || event.type !== 'rotateend') {
                    //         return;
                    //     }
                    //     this.image_list53[index].startAngle = this.image_list53[index].rotation;
                    // });
                    mcList.push(mc);
                });
                this.mcList = mcList;
            });
        },
        onPan(event) {
            const element = event.target.parentNode;
            const index = [].indexOf.call(this.$refs.img, element);
            if (index < 0) {
                return;
            }
            const item = this.image_list53[index];
            if(event.type === 'panstart') {
                element.style.zIndex = 1;
                item.isDragging = true;
                item.startX = item.rights;
                item.startY = item.tops;
            } else if (item.isDragging && event.type === 'panmove') {
                const deltaX = event.deltaX;
                const deltaY = event.deltaY;
                this.image_list53[index].rights = item.startX + deltaX;
                this.image_list53[index].tops = item.startY + deltaY;
                element.style.transform = `translate3d(${this.image_list53[index].rights}px, ${this.image_list53[index].tops}px, 0) rotate(${this.image_list53[index].rotation}deg)`;
            } else if (item.isDragging && event.type === 'panend') {
                this.image_list53[index].isDragging = false;
                element.style.zIndex = "";
            }
            this.websocketsend('2000'+this.sendData+'@'+'pingtu'+JSON.stringify(this.image_list53));

        },
        onRotate(event) {
            const element = event.target.parentNode;
            const index = [].indexOf.call(this.$refs.img, element);
            if (index < 0) {
                return;
            }
            if (event.type === 'rotatestart') {
                this.image_list53[index].startAngle = this.image_list53[index].rotation;
                this.image_list53[index].startRotation = event.rotation;
                const pinch = this.mcList[index].get('pinch');
                if (pinch) {
                    this.mcList[index].recognizeWith(pinch, false);
                }
                if (event.pointers.length !== 2) {
                    this.mcList[index].get('rotate').set({ enable: false });
                    this.mcList[index].get('rotate').set({ enable: true });
                    return;
                }
                this.startRotation = event.rotation;
                event.preventDefault();
            } else if (event.type === 'rotatemove') {
                if (event.pointers.length === 2  && Math.abs(event.rotation - this.image_list53[index].startRotation) > 10) {
                    if (Math.abs(event.deltaX) > 10 || Math.abs(event.deltaY) > 10) {
                        const rotation = Number(this.image_list53[index].startAngle) + Number(event.rotation - this.image_list53[index].startRotation);
                        this.image_list53[index].rotation = rotation % 360;;
                        if (this.image_list53[index].rotation < 0) {
                            this.image_list53[index].rotation += 360;
                        }
                        requestAnimationFrame(() => {// 优化动画性能
                            element.style.transform = `translate3d(${this.image_list53[index].rights}px, ${this.image_list53[index].tops}px, 0) rotate(${this.image_list53[index].rotation}deg)`;
                        });                    }
                }
            }
            this.websocketsend('2000'+this.sendData+'@'+'pingtu'+JSON.stringify(this.image_list53));

        },
        /**
         * 指导语关闭
         * */
        exam_end(text) {
            console.log('指导语关闭')
            this.isQuestion = false
            this.zhidaoyuDjs = false
            // this.timerzdy = null
            if(text) {
                this.isExamjs = true
                this.answer_page()
            }
            this.websocketsend('2000'+this.sendData+'@'+'examjs');
            // if(this.topic.type == 58) {
            //     this.$nextTick(() => {
            //         // this.image_list53.map((item,index) => {
            //         //     this.rotateChange(index)
            //         // })
            //         this.rotateChange()
            //     })
            // }
            // clearInterval(this.timerzdy)
        },
        /**
         * 编码确定按钮
         * */
        submit054() {
            if(!this.isQuestion) {
                this.$message.error('当前主副屏未同步，请稍后进行作答!')
                let answerJson = {
                    id:this.topic.id,
                }
                this.websocketsend('2000'+this.sendData+'@'+'tongBu'+JSON.stringify(answerJson))
                return
            }
            let answer_id = []
            for (let a = 0; a<  this.topic.answer.length;a++) {
                this.topic.answer[a].child.map((item,index) => {
                    if(item.show) {
                        answer_id[a] = item.id
                    }
                })
            }
            // if(answer_id.length < this.topic.answer.length) {
            //     this.$message.error('请选择对应的符号')
            //     return
            // }
            // console.log('answer_id',answer_id)
            // this.topic.answer.map((item,index) => {
            //     item.child.map((a,b) => {
            //         if(a.show == true) {
            //             answer_id.push(a.id)
            //         }
            //     })
            // })
            let params = {
                exam_id: this.exam_id,
                patient_id:this.patient_id,
                question_id: this.topic.id,
                answer_id: String(answer_id)
            }
            this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                if (res.data.code === 1) {
                    this.answer_end()
                    // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                    // this.clearTimerWeb()
                    // let answer ={
                    //     id:this.topic.id
                    // }
                    // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                    // setTimeout(() => {
                    //     this.websockTimer()
                    // },1000)
                } else {
                    this.$message.error(res.data.info)
                }
            })
        },
        /**
         * 编码题型选中
         * */
        typeClick(index,index1) {
            if(this.topic.answer[index].child[index1].show) {
                this.topic.answer[index].child[index1].show = false
            } else {
                let flag = false
                this.topic.answer.map((first,fIndex) => {
                    if(fIndex < index) {
                        let sFlag = false
                        first.child.map((second,sIndex) => {
                            if(second.show) {
                                sFlag = true
                            }
                        })
                        if(!sFlag) {
                            flag = true
                        }
                    }
                })
                if(flag) {
                    this.$message.error('请按从左到右的顺序选择!')
                    return
                }
                this.topic.answer[index].child.map((first, fIndex) => {
                    first.show = false
                })
                this.topic.answer[index].child[index1].show = true
            }
            this.websocketsend('2000'+this.sendData+'@'+'bianma'+JSON.stringify(this.topic.answer));

            // console.log('this.topic.answer[index].child[index1]',this.topic.answer[index].child[index1])
            this.$forceUpdate()
        },
        // tianjia(item) {
        //     let params = {
        //         aid: item.id,
        //         right:item.right,
        //         qid: this.topic.id,
        //         top: item.top,
        //     }
        //     this.$axios.post('api/TrainExam/add_move', this.$qs.stringify(params)).then(res => {
        //
        //     })
        // },
        /**
         * 拖拽结束事件
         * */
        onDragstop(newRect,option) {
            event.preventDefault();
            const THRESHOLD = 50; // 定义一个常量，存储数字30
            let that = this;
            if(that.topic.type == 65) {
                // let isshow = ''
                function updateImageListItem(option, item, newRect) {
                    that.DragResize = false
                    const optionData = that.image_list51[option];
                    if (newRect.left < item.right + THRESHOLD &&
                        newRect.left > item.right - THRESHOLD &&
                        newRect.top < item.top + THRESHOLD &&
                        newRect.top > item.top - THRESHOLD &&
                        item.image == ''
                    ) {
                        // console.log('1111111111')
                        // item.img = that.image_list51[option].img
                        // item.id = that.image_list51[option].id
                        // that.image_list51[option].num = 0
                        // that.image_list51[option].rights = newRect.left
                        // that.image_list51[option].tops = newRect.top
                        Vue.set(item, 'image', that.image_list51[option].img);
                        // Vue.set(item, 'id', that.image_list51[option].id);
                        Vue.set(optionData, 'num', 0);
                        Vue.set(that.image_list51[option], 'rights', newRect.left);
                        Vue.set(that.image_list51[option], 'tops', newRect.top);
                        that.answerId65 = item.id
                        let answerJson = {
                            image_list51:that.image_list51,
                            image_list51_answer:that.image_list51_answer,
                            answerId65:that.answerId65
                        }
                        that.websocketsend('2000'+that.sendData+'@'+'pincou'+JSON.stringify(answerJson));

                    } else {
                        that.$nextTick(() => {
                            Vue.set(that.image_list51[option], 'rights', that.image_list51[option].right);
                            Vue.set(that.image_list51[option], 'tops', that.image_list51[option].top);
                            that.DragResize = true;
                            // that.image_list51.forEach((item1,index1) => {
                            //     if(index1 == option) {
                            //         item1.rights = item1.right
                            //         item1.tops = item1.top
                            //     }
                            // })
                            // that.image_list51=JSON.parse(JSON.stringify(that.image_list51));
                            // that.image_list51[option].rights = that.image_list51[option].right
                            // that.image_list51[option].tops = that.image_list51[option].top
                            // console.log(11, that.image_list51[option].rights, that.image_list51[option].right, that.image_list51[option].tops, that.image_list51[option].top)
                        })
                    }
                    // that.DragResize = true
                }
                that.image_list51_answer.forEach((item, index) => {
                    updateImageListItem(option, item, newRect)
                })
                // let answerJson = {
                //     image_list51:that.image_list51,
                //     image_list51_answer:that.image_list51_answer
                // }
                // that.websocketsend('1000'+that.sendData+'@'+'pincou'+JSON.stringify(answerJson));
            }
            // else if (that.topic.type == 53) {
            //     that.$nextTick(() => {
            //         that.image_list53[option].rights = newRect.left
            //         that.image_list53[option].tops = newRect.top
            //         that.websocketsend('1000'+that.sendData+'@'+'mukuai'+JSON.stringify(that.image_list53));
            //     })
            //
            // }
            // let a = ''
            // if(that.image_list53[option].rights < that.image_list53[option].right+60 && that.image_list53[option].rights > that.image_list53[option].right-60
            //     && that.image_list53[option].tops < that.image_list53[option].top+60 && that.image_list53[option].tops > that.image_list53[option].top-60) {
            //     that.$nextTick(() => {
            //         that.image_list53[option].rights = Number(that.image_list53[option].right)
            //         that.image_list53[option].tops = Number(that.image_list53[option].top)
            //         // if(that.topic.type == 65) {
            //         //     console.log('that.image_list53_answer',typeof(that.image_list53_answer))
            //         //     if (!that.image_list53_answer.includes(that.image_list53[option].id)) {
            //         //         that.image_list53_answer.push(that.image_list53[option].id);
            //         //     }
            //         // }
            //     })
            // } else {
            //     // if(that.topic.type == 65) {
            //     //     if(that.image_list53_answer .length>0) {
            //     //         that.image_list53_answer = that.image_list53_answer.filter(item => item != that.image_list53[option].id)
            //     //     }
            //     //
            //     // }
            //
            // }
        },
        /**
         * 拖拽时事件
         * */
        onDragging(newRect,option) {
            event.preventDefault();
            // console.log(newRect.left)
            let that = this
            if(that.topic.type == 65) {
                that.$nextTick(() => {
                    // console.log('that.permutationNum',that.permutationNum)
                    if (that.permutationNum === 1) {
                        that.isDragging = true;
                        that.image_list51[option].rights = that.image_list51[option].right
                        that.image_list51[option].tops = that.image_list51[option].top
                        that.isDragging = false;
                        return;
                    }
                    that.isDragging = true;
                    that.image_list51[option].rights = newRect.left
                    that.image_list51[option].tops = newRect.top
                    that.isDragging = false;
                    // that.$refs.imgDrag[option].left = newRect.left
                    // that.$refs.imgDrag[option].top = newRect.top
                })
                // let answerJson = {
                //     image_list51:that.image_list51,
                //     // image_list51_answer:that.image_list51_answer
                // }
                // that.websocketsend('1000'+that.sendData+'@'+'pincoe'+JSON.stringify(answerJson));
            }
        },
        /**
         * 确定排列
         * */
        permutation() {
            if(!this.isQuestion) {
                this.$message.error('当前主副屏未同步，请稍后进行作答!')
                let answerJson = {
                    id:this.topic.id,
                }
                this.websocketsend('2000'+this.sendData+'@'+'tongBu'+JSON.stringify(answerJson))
                return
            }
            if(this.topic.type == 65) {
                if(this.answerId65 == '') {
                    this.$message.error('请摆放')
                    return
                }
                // let answer_id = []
                // let a = []
                // this.image_list51_answer.map((item,index) => {
                //     // if(item.id) {
                //     //     a.push(item.id)
                //     // }
                //     answer_id.push(item.id)
                // })
                //
                // console.log('answer_id',answer_id,this.image_list51_answer)
                // if(a.length<=0) {
                //     this.$message.error('请排列顺序')
                //     return
                // }
                let params = {
                    exam_id: this.exam_id,
                    patient_id:this.patient_id,
                    question_id: this.topic.id,
                    answer_id: this.answerId65,
                    // score: answer_id.length > 0 ? '' : 0
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)

                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            } else if (this.topic.type == 58) {
                // console.log('this.image_list53_answer',this.image_list53_answer)
                // let answer_id = []
                // this.image_list53_answer.map((item,index) => {
                //     answer_id.push(item)
                // })
                // let params = {
                //     exam_id: this.$route.query.exam_id,
                //     patient_id:this.$route.query.patient_id,
                //     question_id: this.topic.id,
                //     answer_id: answer_id,
                //     image_list52:this.image_list53
                // }
                // this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                //     if (res.data.code === 1) {
                //         this.answer_end()
                //     } else {
                //         this.$message.error(res.data.info)
                //     }
                // })
            }
        },
        /**
         * type51  图片初始位置
         * */
        image51Wei() {
            let that = this
            // console.log('that.image_list51',that.image_list51)
            that.image_list51[0].rights =700
            that.image_list51[0].right = 700
            that.image_list51_answer[0].right = 100
            that.image_list51_answer[1].right = 370
            that.image_list51_answer[2].right = 620
            that.image_list51_answer[3].right = 870
            that.image_list51_answer[4].right = 1120
            that.image_list51_answer[5].right = 1370
            that.$forceUpdate()
        },
        /**
         * 重新排列
         * */
        rearrange(i) {
            let that = this
            if(i == 65) {
                that.answerId65 = ''
                that.permutationNum = 1
                that.num = 0
                that.image_list51 = []
                that.DragResize = false
                // this.image_list51 = []
                // this.image_list51 = this.topic.answer
                that.$nextTick(() => {
                    that.image51Wei()
                })
                let a = {
                    img:this.topic.title_img,
                    tops: 180,
                    top :180
                }
                this.image_list51.push(a)
                this.image_list51_answer.map((item,index) => {
                    item.top = 440
                    item.image = ''
                })
                that.DragResize = true
                setTimeout(() => {
                    that.permutationNum = 0
                },1000)
                let answerJson = {
                    image_list51:that.image_list51,
                    image_list51_answer:that.image_list51_answer,
                    answerId65:that.answerId65,
                }
                that.websocketsend('2000'+that.sendData+'@'+'pincou'+JSON.stringify(answerJson));

            } else if (i == 53) {
                that.presentInterface()
            }
            that.$forceUpdate()
        },
        /**
         * 当前题目接口
         * */
        async presentInterface() {
            let params = {
                exam_id: this.exam_id,
                patient_id:this.patient_id,
                question_id: this.topic.id,
            }
            await this.$axios.post('api/TrainExam/now', params).then(res => {
                this.topic = res.data.data;
                this.options = Number(this.topic.answer_id);
                this.answer_page()
            })
        },
        /**
         * 点击放大
         * */
        sizeBig() {
            let titleNum = parseFloat(document.getElementById('title').style.fontSize);
            let radioNum = parseFloat(document.getElementById('radio').style.fontSize);
            titleNum = titleNum + 1;
            radioNum = radioNum + 1;
            document.getElementById('title').style.fontSize = titleNum + 'px';
            document.getElementById('radio').style.fontSize = radioNum + 'px';
            if (titleNum > 50 && radioNum > 48) {
                document.getElementById('title').style.fontSize = 50 + 'px';
                document.getElementById('radio').style.fontSize = 48 + 'px';
            }
        },
        /**
         * 点击缩小
         * */
        sizeSmall() {
            let titleNum = parseFloat(document.getElementById('title').style.fontSize);
            let radioNum = parseFloat(document.getElementById('radio').style.fontSize);
            titleNum = titleNum - 1;
            radioNum = radioNum - 1;
            document.getElementById('title').style.fontSize = titleNum + 'px';
            document.getElementById('radio').style.fontSize = radioNum + 'px';
            if (titleNum < 14 && radioNum < 12) {
                document.getElementById('title').style.fontSize = 14 + 'px';
                document.getElementById('radio').style.fontSize = 12 + 'px';
            }
        },
        /**
         * 倒计时
         * */
        countDowm() {
            let self = this
            clearInterval(this.promiseTimer)
            this.promiseTimer = setInterval(function () {
                if (self.hour === 0) {
                    if (self.minute !== 0 && self.second === 0) {
                        self.second = 59
                        self.minute -= 1
                    } else if (self.minute === 0 && self.second === 0) {
                        self.second = 0
                        self.$emit('countDowmEnd', true)
                        clearInterval(self.promiseTimer)
                        if(self.topic.type == 65) {
                            self.$message.error('时间超时，进入下一题!')
                            self.permutation()
                        } else if(self.topic.type == 61) {
                            self.$message.error('时间超时，进入下一题!')
                            self.submit054()
                        }  else if (self.topic.type == 59) {
                            self.$message.error('时间超时，进入下一题!')
                            let params = {
                                exam_id: self.exam_id,
                                patient_id:self.patient_id,
                                question_id: self.topic.id,
                                score:''
                            }
                            self.$axios.post('api/TrainExam/aswer', self.$qs.stringify(params)).then(res => {
                                if (res.data.code === 1) {
                                    self.answer_end()
                                    // self.clearTimerWeb()
                                    // let answer ={
                                    //     id:self.topic.id
                                    // }
                                    // self.websocketsend('1000'+self.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                                    // setTimeout(() => {
                                    //     self.websockTimer()
                                    // },1000)
                                    // self.websocketsend('1000'+self.sendData+'@'+'answer_end');
                                } else {
                                    self.$message.error(res.data.info)
                                }
                            })
                        } else {
                            self.dialogChuan = true;
                            if (self.topic.type == 63) {
                                self.generate()
                            }
                        }
                    } else {
                        self.second -= 1
                    }
                } else {
                    if (self.minute !== 0 && self.second === 0) {
                        self.second = 59
                        self.minute -= 1
                    } else if (self.minute === 0 && self.second === 0) {
                        self.hour -= 1
                        self.minute = 59
                        self.second = 59
                    } else {
                        self.second -= 1
                    }
                }
            }, 1000)
        },
        formatNum(num) {
            return num < 10 ? '0' + num : '' + num
        },
        /**
         * 题目页面显示
         * */
        answer_page() {
            if(this.screenQ_id !== this.topic.id) {
                this.isQuestion = false
            }
            if (this.topic.points > 0) {
                this.time_show = true
                this.dialogChuan = false
                this.hour = Math.floor((this.topic.points / 3600) % 24)
                this.minute = Math.floor((this.topic.points / 60) % 60)
                this.second = Math.floor(this.topic.points % 60)
                clearInterval(this.promiseTimer)
                this.promiseTimer = ''
                this.countDowm()
            } else {
                clearInterval(this.promiseTimer)
                this.promiseTimer = ''
                this.time_show = false
                this.dialogChuan = false
            }
            if(this.topic.type == 62 || this.topic.type == 64 || this.topic.type == 66) {
                if(this.topic.p_id == 0) {
                    this.options_50 = this.topic.answer_id
                } else {
                    this.options_50 = this.topic.p_id
                    this.options_50_display()
                }
            } else if (this.topic.type == 65) {
                this.image_list51 = []
                this.image_list51_answer = []
                this.image_list51_answer =  this.topic.answer
                if (this.topic.answer_id == '') {
                    let a = {
                        img:this.topic.title_img,
                        tops: 180,
                        top :180
                    }
                    this.image_list51.push(a)
                    this.image_list51_answer.map((item,index) => {
                        item.top = 440
                        item.image = ''
                    })
                    this.image51Wei()
                } else {
                    // let answer_id = this.topic.answer_id.split(',');
                    // for (let a = 0; a < this.image_list51.length; a++) {
                    //     for (let c = 0; c < answer_id.length; c++) {
                    //         if (this.image_list51[a].id == answer_id[c]) {
                    //             this.image_list51[a].num = 0
                    //         }
                    //     }
                    //     let b = {
                    //         num: a + 1
                    //     }
                    //     this.image_list51_answer.push(b)
                    // }
                    // this.image_list51_answer.map((item, index) => {
                    //     this.image_list51_answer[index].id = answer_id[index]
                    // })
                    // for (let a = 0; a < this.image_list51.length; a++) {
                    //     for (let c = 0; c < this.image_list51_answer.length; c++) {
                    //         if (this.image_list51_answer[c].id == this.image_list51[a].id) {
                    //             this.image_list51_answer[c].img = this.image_list51[a].img
                    //         }
                    //     }
                    // }
                    // this.num = answer_id.length
                }
            }else if (this.topic.type == 68 || this.topic.type == 58) {
                if(this.topic.answer_id !== '') {
                    this.image_list53 = this.topic.image_list52
                    this.image_list53.map((item,index) => {
                        // item.right = Number(item.right)
                        // item.top = Number(item.top)
                        item.rights = Number(item.rights)
                        item.tops = Number(item.tops)
                        item.rotation = Number(item.rotation)
                        item.isDragging = false
                        item.startX = 0
                        item.startY = 0
                        item.startAngle = null
                    })
                    this.$nextTick(() => {
                        const images = this.$refs.img; // 获取需要手势操作的元素
                        this.image_list53.map((item,index) => {
                            images[index].style.transform = `translate3d(${item.rights}px, ${item.tops}px, 0) rotate(${item.rotation}deg)`
                        })
                        this.rotateChange()
                    })
                    if(this.topic.type == 58) {
                        this.type58id = 1
                    }
                } else {
                    if(this.topic.type == 58 && this.topic.answer_score && this.topic.example !== 1) {
                        this.image_list53 = this.topic.image_list52
                        this.image_list53.map((item,index) => {
                            // item.right = Number(item.right)
                            // item.top = Number(item.top)
                            item.rights = Number(item.rights)
                            item.tops = Number(item.tops)
                        })
                        this.$nextTick(() => {
                            const images = this.$refs.img; // 获取需要手势操作的元素
                            this.image_list53.map((item,index) => {
                                images[index].style.transform = `translate3d(${item.rights}px, ${item.tops}px, 0) rotate(${item.rotation}deg)`
                            })
                            this.rotateChange()
                        })
                        if(Number(this.topic.answer_score) >= 0 && Number(this.topic.answer_score) < 10) {
                            this.type58id = 2
                            this.score58id = Number(this.topic.answer_score)
                        }

                    } else {
                        this.image_list53 = this.topic.answer
                        this.image_list53.map((item,index) => {
                            // item.right = Number(item.right)
                            // item.top = Number(item.top)
                            item.rights = Number(item.rights)
                            item.tops = Number(item.tops)
                            // item.transform = ''
                            item.rotation = 0
                            item.isDragging = false
                            item.startX = 0
                            item.startY = 0
                            item.startAngle = null
                        })
                    }
                    if((this.topic.type == 58 || this.topic.type == 68) && !this.zhidaoyuDjs) {
                        // console.log('33333')
                        this.$nextTick(() => {
                            this.rotateChange()
                        })

                    }
                }
                // if(this.topic.type == 58) {
                //     if (this.topic.answer_id.length<0) {
                //         this.image_list53_answer = []
                //     } else {
                //         let answer_id = this.topic.answer_id.split(',');
                //         this.image_list53_answer = answer_id
                //     }
                //
                // }
            } else if(this.topic.type == 52) {
                if(this.topic.answer_id == '') {
                    for (let a = 0; a < 12; a++) {
                        let b = {
                            num: a + 1,
                            color:'#D3D3D3'
                        }
                        this.image_list52.push(b)
                    }
                } else {
                    this.image_list52 = this.topic.image_list52
                }

                // if(this.topic.p_id == 0) {
                //     this.options_50 = this.topic.answer_id
                // } else {
                //     this.options_50 = this.topic.p_id
                //     this.options_50_display()
                // }
            } else if(this.topic.type == 61) {
                let answer_id = this.topic.answer_id
                if(answer_id.length > 0) {
                    // console.log('answer_id',answer_id)
                    this.topic.answer.map((item,index) => {
                        item.child.map((a,b) => {
                            // console.log('a.id',a.id)
                            // console.log('answer_id.includes(a.id)',answer_id.includes(a.id))
                            if(answer_id.includes(a.id)) {
                                a.show = true
                            }
                        })
                    })
                }
                // console.log('this.topic.answer',this.topic.answer)
            } else if(this.topic.type == 63) {
                this.isDrawing= false
                this.lastX = 0
                this.lastY = 0
                this.canvas = null
                this.ctx = null
                setTimeout(() => {
                    const canvasBox = document.getElementById('canvasBox')
                    const mazeImg = document.getElementById('mazeImg')
                    canvasBox.width = mazeImg.width
                    canvasBox.height = mazeImg.height
                    this.canvas = canvasBox
                    // console.log('canvasBox',canvasBox)
                    this.ctx = canvasBox.getContext('2d')
                },200)
            } else if (this.topic.type === 69) {
                this.huaban = true
                setTimeout(() => {
                    this.initCanvas()
                },200)
            }
            // this.$forceUpdate()
            if(this.topic.type == 63 || this.topic.type == 67 || this.topic.type == 68) {
                setTimeout(() => {
                    console.log('副屏渲染完成')
                    let answerJson = {
                        id:this.topic.id,
                    }
                    this.websocketsend('2000'+this.sendData+'@'+'isQues'+JSON.stringify(answerJson))
                },2000)
            } else {
                let answerJson = {
                    id:this.topic.id,
                }
                this.websocketsend('2000'+this.sendData+'@'+'isQues'+JSON.stringify(answerJson))
            }
            this.showTitle = true
            if(this.topic.type == 55) {
                this.isExamjs = true
                setTimeout(()=> {
                    this.isExamjs = false
                },1000)
            }
            this.readTopic()
        },
        /**
         * 获取题目
         * */
        async getTopic() {
            let that = this
            that.answerList = []
            that.image_list51_answer = []
            that.image_list53 = []
            // this.image_list53_answer = []
            that.score58id = ''
            that.type58id = ''
            that.num = 0
            let params = {
                exam_id: that.exam_id,
                patient_id:that.patient_id,
            }
            await that.$axios.post('api/TrainExam/start', params).then(res => {
                that.topic = res.data.data;
                that.options = Number(that.topic.answer_id);
                if (res.data.data.zhidaoyu && res.data.data.zhidaoyu.length>0) {
                    that.zhidaoyuDjs = true
                    that.readTopic(res.data.data.zhidaoyu)
                    // var timerzdy = setInterval(() => {
                    //     if (this.zhidaoyuDjs == 0) {
                    //         this.exam_end();
                    //         clearInterval(timerzdy)
                    //         this.readTopic()
                    //     } else {
                    //         this.zhidaoyuDjs--;
                    //     }
                    // }, 1000)
                } else {
                    // this.readTopic()
                    that.answer_page()
                }
            })
        },
        /**
         * 重复语言
         * */
        readTopic(zhidaoyu) {
            console.log('readTopic')
            // console.log('zhidaoyu',zhidaoyu)
            if(zhidaoyu) {
                this.isExamjs = true
            }
            window.speechSynthesis.cancel();
            this.presetVoice();
            var synth = window.speechSynthesis;
            // console.log('utterThis',utterThis)
            var utterThis = null
            if (zhidaoyu) {
                utterThis = new SpeechSynthesisUtterance(this.zhidaoyuVoice);
            } else {
                utterThis = new SpeechSynthesisUtterance(this.titleVoice);
            }
            utterThis.volume = 1  // 声音的音量
            utterThis.rate = 1 // 语速，数值，默认值是1，范围是0.1到10
            utterThis.pitch = 1 // 表示说话的音高，数值，范围从0（最小）到2（最大）。默认值为1
            synth.speak(utterThis);
            // utterThis = new SpeechSynthesisUtterance('请听答案：' + this.answerVoice);
            // utterThis.volume = 1  // 声音的音量
            // utterThis.rate = 1 // 语速，数值，默认值是1，范围是0.1到10
            // utterThis.pitch = 1 // 表示说话的音高，数值，范围从0（最小）到2（最大）。默认值为1
            // synth.speak(utterThis);
            // console.log('读完22222')
            // 播放结束后调用
            utterThis.onend = (event) => {
                console.log('utterThis.onend')
                if (zhidaoyu) {
                    console.log('zhidaoyu')
                    this.exam_end('audio_end')
                }
            }
        },
        presetVoice() {
            // this.titleVoice = this.topic.title.split('.')[1];
            if(this.zhidaoyuDjs) {
                this.zhidaoyuVoice =  this.topic.zhidaoyu.replace(/\.|-|\(|\)/g, '、')
                // console.log('this.zhidaoyuVoice',this.zhidaoyuVoice,this.topic.zhidaoyu)
            } else {
                // console.log(111)
                if(this.topic.intro) {
                    let arr = this.topic.intro.split(".")
                    // console.log('arr',arr)
                    if(arr.length == 1) {
                        let title = arr[0]
                        this.titleVoice = title.replace(/\.|-|\(|\)/g, '、')
                    } else {
                        let title = arr[1]
                        this.titleVoice = title.replace(/\.|-|\(|\)/g, '、')
                    }

                }
            }
        },
        /**
         * 答题结束
         * */
        answer_end() {
            this.options_50 = ''
            this.answerList = []
            this.image_list52 = []
            this.image_list53 = []
            this.image_list53_answer = []
            this.score58id = ''
            this.type58id = ''
            this.scoreList63 = []
            if(this.topic == 69) {
                this.huaban = false
                this.clickClear()
            }
            if (this.topic.all_count > this.topic.now_count) {
                console.log('答题,下一题 ')
                this.nextTopic()
            } else if (this.topic.now_count == this.topic.all_count) {
                console.log('答题,结束 ')
                // console.log('结束1111')
                // this.readTopic('')
                this.clearTimerWeb()
                setTimeout(() => {
                    this.websocketsend('2000'+this.sendData+'@'+'jieshu');
                },1000)
                window.speechSynthesis.cancel()
                this.$router.push({
                    name: 'TerminalEnd',
                    query: {
                        exam_id: this.exam_id,
                        patient_id:this.patient_id,
                    }
                })


                // setTimeout(() => {
                //     this.websockTimer()
                // },1000)

            }
        },
        /**
         * 答题
         * */
        answerJudgment(answer_id,index) {
            if(this.topic.type == 59) {
                let params = {
                    exam_id: this.exam_id,
                    patient_id:this.patient_id,
                    question_id: this.topic.id,
                    answer_id: answer_id,
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)
                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            } else if (this.topic.type == 62 || this.topic.type == 64|| this.topic.type == 66) {
                let answerList = []
                this.topic.answer.map((item,index) => {
                    if(item.id == answer_id) {
                        answerList = item.child
                    }
                })
                if(answerList.length > 0) {
                    this.options_50 = answer_id
                    this.answerList = answerList
                } else {
                    let params = {
                        exam_id: this.exam_id,
                        patient_id:this.patient_id,
                        question_id: this.topic.id,
                        answer_id: answer_id,
                    }
                    this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                        if (res.data.code === 1) {
                            this.answer_end()
                            // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                            // this.clearTimerWeb()
                            // let answer ={
                            //     id:this.topic.id
                            // }
                            // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                            // setTimeout(() => {
                            //     this.websockTimer()
                            // },1000)
                        } else {
                            this.$message.error(res.data.info)
                        }
                    })
                }
            } else if (this.topic.type == 65) {
                // this.num++;
                // this.image_list51_answer.map((item,index) => {
                //     if(item.num == this.num) {
                //         item.img = answer_id.img
                //         item.id = answer_id.id
                //     }
                // })
                // this.image_list51.map((item,index) => {
                //     if(item.id == answer_id.id) {
                //         item.num = 0
                //     }
                // })
                // this.$forceUpdate()
            } else if (this.topic.type == 52) {
                this.image_list52.map((item,index) => {
                    if(item.num == answer_id) {
                        if(item.color == '#F76664') {
                            item.color = '#D3D3D3'
                        } else {
                            item.color = '#F76664'
                        }

                    }
                })
                this.websocketsend('2000'+this.sendData+'@'+'colors'+JSON.stringify(this.image_list52))

                this.$forceUpdate()
            } else if(this.topic.type == 55 || this.topic.type == 60) {
                let params = {
                    exam_id: this.exam_id,
                    patient_id:this.patient_id,
                    question_id: this.topic.id,
                    answer_id: answer_id,
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)
                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            } else if (this.topic.type == 67) {
                // console.log(answer_id,index)
                if(answer_id.isshow) {
                    this.topic.answer[index].isshow = false
                } else {
                    this.topic.answer[index].isshow = true
                }
                this.websocketsend('2000'+this.sendData+'@'+'choice'+JSON.stringify(this.topic.answer));
                this.$forceUpdate()
            }
        },
        /**
         * 分类测验二级点击
         * */
        answer50(answer_id) {
            let params = {
                exam_id: this.exam_id,
                patient_id:this.patient_id,
                question_id: this.topic.id,
                answer_id: answer_id,
            }
            this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                if (res.data.code === 1) {
                    this.answer_end()
                    // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                    // this.clearTimerWeb()
                    // let answer ={
                    //     id:this.topic.id
                    // }
                    // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                    // setTimeout(() => {
                    //     this.websockTimer()
                    // },1000)
                } else {
                    this.$message.error(res.data.info)
                }
            })
        },
        /**
         * 拼图选项点击
         * */
        answer58(answer_id) {
            if(this.topic.type == 58) {
                if (answer_id == 1) {
                    let a = []
                    this.topic.answer.map((item,index) => {
                        a.push(item.id)
                    })
                    // const images = this.$refs.img; // 获取需要手势操作的元素
                    // this.image_list53.map((item,index) => {
                    //     item.transform = images[index].style.transform
                    // })
                    let params = {
                        exam_id: this.exam_id,
                        patient_id:this.patient_id,
                        question_id: this.topic.id,
                        answer_id: String(a),
                        image_list52:this.image_list53
                    }
                    this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                        if (res.data.code === 1) {
                            this.answer_end()
                            // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                            // this.clearTimerWeb()
                            // let answer ={
                            //     id:this.topic.id
                            // }
                            // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                            // setTimeout(() => {
                            //     this.websockTimer()
                            // },1000)
                        } else {
                            this.$message.error(res.data.info)
                        }
                    })
                }
            }  else if(this.topic.type == 63) {
                let a = []
                this.topic.answer.map((item,index) => {
                    if(answer_id == item.id) {
                        a = item.child
                    }
                })
                if (a.length > 0) {
                    this.scoreList63 = a
                } else {
                    let params = {
                        exam_id: this.$route.query.exam_id,
                        patient_id:this.$route.query.patient_id,
                        question_id: this.topic.id,
                        answer_id: answer_id
                    }
                    this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                        if (res.data.code === 1) {
                            this.answer_end()
                            // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                            // this.clearTimerWeb()
                            // let answer ={
                            //     id:this.topic.id
                            // }
                            // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                            // setTimeout(() => {
                            //     this.websockTimer()
                            // },1000)

                        } else {
                            this.$message.error(res.data.info)
                        }
                    })
                }

            }

        },
        /**
         * 拼图 错误答案
         * */
        score58answer(answer_id) {
            // const images = this.$refs.img; // 获取需要手势操作的元素
            // this.image_list53.map((item,index) => {
            //     item.transform = images[index].style.transform
            // })
            if(this.topic.type == 58) {
                let params = {
                    exam_id: this.$route.query.exam_id,
                    patient_id:this.$route.query.patient_id,
                    question_id: this.topic.id,
                    answer_id: '',
                    score:answer_id,
                    image_list52:this.image_list53
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)

                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            } else {
                let params = {
                    exam_id: this.$route.query.exam_id,
                    patient_id:this.$route.query.patient_id,
                    question_id: this.topic.id,
                    answer_id: answer_id,
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)

                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            }
        },
        /**
         * 选择题答题
         * */
        answer(answer_id) {
            if(this.topic.type == 52) {
                let params = {
                    exam_id: this.exam_id,
                    patient_id:this.patient_id,
                    question_id: this.topic.id,
                    answer_id: answer_id,
                    image_list52:this.image_list52
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)
                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            } else if(this.topic.type == 68) {
                let params = {
                    exam_id: this.exam_id,
                    patient_id:this.patient_id,
                    question_id: this.topic.id,
                    answer_id: answer_id,
                    image_list52:this.image_list53
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)
                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            } else {
                let params = {
                    exam_id: this.exam_id,
                    patient_id:this.patient_id,
                    question_id: this.topic.id,
                    answer_id: answer_id,
                }
                this.$axios.post('api/TrainExam/aswer', this.$qs.stringify(params)).then(res => {
                    if (res.data.code === 1) {
                        this.answer_end()
                        // this.websocketsend('1000'+this.sendData+'@'+'answer_end');
                        // this.clearTimerWeb()
                        // let answer ={
                        //     id:this.topic.id
                        // }
                        // this.websocketsend('1000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));
                        // setTimeout(() => {
                        //     this.websockTimer()
                        // },1000)
                    } else {
                        this.$message.error(res.data.info)
                    }
                })
            }

        },
        /**
         * 下一题点击
         * */
        async nextTopic(text) {
            if(text == 'next') {
                this.websocketsend('2000'+this.sendData+'@'+'next_topic');
            }
            this.options_50 = ''
            this.answerList = []
            this.image_list52 = []
            this.image_list53 = []
            this.image_list53_answer = []
            this.score58id = ''
            this.type58id = ''
            this.scoreList63 = []
            this.imgSrc = ''
            this.num = 0
            if (this.topic.all_count == this.topic.now_count) {
                // console.log('结束')
                this.$message.error('已经是最后一题了!')
                return
            }
            let answer ={
                id:this.topic.id
            }
            let params = {
                exam_id: this.exam_id,
                patient_id:this.patient_id,
                question_id: this.topic.now_count == this.topic.all_count ? 0 : this.topic.id,
            }
            await this.$axios.post('api/TrainExam/next', this.$qs.stringify(params)).then(res => {
                // console.log('res.data.data',res.data.data)
                if(res.data.data.type) {
                    // console.log(res)
                    this.topic = res.data.data;
                    this.options = Number(this.topic.answer_id);

                    this.$forceUpdate()
                    if(res.data.data.zhidaoyu) {
                        this.zhidaoyuDjs = true
                        this.readTopic(res.data.data.zhidaoyu)
                        // this.zhidaoyuDjs = 10
                        // // clearInterval(this.timerzdy)
                        // // this.timerzdy = null
                        // var timerzdy = setInterval(() => {
                        //     if (this.zhidaoyuDjs == 0) {
                        //         this.exam_end();
                        //         clearInterval(timerzdy)
                        //         this.readTopic()
                        //     } else {
                        //         this.zhidaoyuDjs--;
                        //     }
                        // }, 1000)
                    } else {
                        this.answer_page()
                        // this.readTopic()
                    }
                } else {
                    // console.log('结束2222')
                    window.speechSynthesis.cancel()
                    this.options_50 = ''
                    this.answerList = []
                    this.image_list52 = []
                    this.image_list53 = []
                    this.image_list53_answer = []
                    this.$router.push({
                        name: 'TerminalEnd',
                        query: {
                            exam_id: this.exam_id,
                            patient_id:this.patient_id,
                        }
                    })
                }
                if(!text) {
                    this.websocketsend('2000'+this.sendData+'@'+'naxtTi'+JSON.stringify(answer));

                }

            })
        },
        /**
         * 分类测验一级点击完后二级内容
         * */
        options_50_display() {
            let answerList = []
            this.topic.answer.map((item,index) => {
                if(item.id == this.topic.p_id) {
                    answerList = item.child
                }
            })
            if(answerList.length > 0) {
                this.answerList = answerList
            }
        },
        /**
         * 点击上一题
         * */
        // async prevTopic(text) {
        //     if(text) {
        //         this.clearTimerWeb()
        //         this.websocketsend('1000'+this.sendData+'@'+'prev_topic');
        //         setTimeout(() => {
        //             this.websockTimer()
        //         },1000)
        //     }
        //     this.answerList = []
        //     this.image_list51_answer = []
        //     this.num = 0
        //     this.image_list52 = []
        //     this.image_list51 = []
        //     this.image_list53 = []
        //     if (this.topic.now_count == 1) {
        //         this.$message.error('已经是第一题了!')
        //         return;
        //     }
        //     let params = {
        //         exam_id: this.exam_id,
        //         patient_id:this.patient_id,
        //         question_id: this.topic.id,
        //     }
        //     await this.$axios.post('api/TrainExam/upper', this.$qs.stringify(params)).then(res => {
        //         this.topic = res.data.data;
        //         this.options = Number(this.topic.answer_id);
        //         this.answer_page()
        //         this.$forceUpdate()
        //         // this.readTopic();
        //     })
        // },
        /**
         * 结束按钮点击事件
         * */
        endExam() {
            this.$confirm('确定结束吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                window.speechSynthesis.cancel()
                this.$router.push(
                    {
                        name: 'TerminalEnd',
                        query: {
                            exam_id: this.exam_id,
                            patient_id:this.patient_id,
                        }
                    }
                )
            })

        },
    },
}
</script>

<style scoped lang="scss">
.maze-img {
    //width: 1000px;
    //height: 200px;
    position: absolute;
    top: 200px;
    left:100px;
    z-index: -1;
}

.maze-canvas {
    //width: 1000px;
    //height: 200px;
    position: absolute;
    top: 200px;
    left:100px;
}
.image-wrapper {
    position: absolute;
    //width: 240px;
    //height: 240px;

    //overflow: hidden;
    z-index: 999;
}
.drag-image {
    width: 100%;
    height: 100%;
    //object-fit: cover;
}
.huaban {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-color: #000;
    li {
        list-style-type: none;
    }

    ul {
        padding-left: 10px
    }

    h1 {
        position: fixed;
        left: 15px;
        top: 5px;
        width: 400px;
        height: 60px;
        color: #ff5e83;
        font-size: 26px;
        line-height: 60px;
        text-align: center;
    }

    .canvas-box {
        position: fixed;
        left: 400px;
        top: 10px;
        display: block;
        cursor: pointer;
        background-color: #FFFFFF;
        border: 1px solid #CCCCCC;
    }

    .container {
        width: 400px;
        height: 60px;
        position: fixed;
        top: 10px;
    }

    .container h2 {
        width: 100%;
        height: 60px;
        font-size: 22px;
        text-align: center;
        color: #ff377e;
        font-weight: normal;
        line-height: 60px;
        border-bottom: 1px solid #000;
    }

    .container h3 {
        width: 100%;
        height: 30px;
        font-size: 18px;
        text-align: center;
        color: #41b1ff;
        font-weight: normal;
        line-height: 30px;
    }

    .type {
        width: 100%;
        //height: auto;
        margin-top: 30px;
        //padding-bottom: 10px;
        //border-bottom: 1px solid #666;
    }

    .type:after {
        content: "";
        display: block;
        clear: both;
    }

    .type li {
        float: left;
        width: 160px;
        height: 55px;
        margin: 0 auto;
        background-color: #20BE18;
        color: #fff;
        font-size: 20px;
        line-height: 55px;
        text-align: center;
        //margin-bottom: 15px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.7s;
    }

    .type li:hover {
        background-color: #fff;
        color: #20BE18;
    }

    .type .typeactive {
        background-color: #fff;
        color: #20BE18;
    }

    .type li:nth-child(odd) {
        margin-left: 15px;
    }

    .type li:nth-child(even) {
        margin-left: 25px;
    }

    .style {
        width: 100%;
        height: 40px;
        margin-top: 10px;
    }

    .style li {
        float: left;
        width: 160px;
        height: 55px;
        background-color: #FFBC00;
        color: #fff;
        font-size: 20px;
        line-height: 55px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.7s;
    }

    .style li:hover {
        color: #ffa800;
        background-color: #fff;
        box-shadow: 0 0 10px rgba(255, 232, 95, 0.77);
    }

    .style .styleactive {
        color: #ffa800;
        background-color: #fff;
        box-shadow: 0 0 10px rgba(255, 232, 95, 0.77);
    }

    .style li:nth-child(1) {
        margin-left: 25px;
    }

    .style li:nth-child(2) {
        margin-left: 20px;
    }
    //
    //.poly {
    //  position: relative;
    //
    //  &:hover .bian {
    //    transform: scale(1.2);
    //    opacity: 1;
    //  }
    //}

    .bian {
        position: absolute;
        left: 100px;
        top: 0;
        width: 160px;
        height: auto;
        transition: transform 0.3s;
        border-radius: 5px;
        background-color: #EC494E;
        overflow: hidden;
        transform: scale(0);
        opacity: 0;
        // display: none;
    }

    .bian span {
        display: block;
        float: left;
        width: 40px;
        height: 45px;
        font-size: 20px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        color: #fff;
        transition: all 0.7s;
    }

    .bian input {
        float: left;
        width: 45px;
        height: 35px;
        margin-top: 5px;
        border: 1px solid #fff;
        box-sizing: border-box;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color: #fff;
        background: #EC494E;
        border-radius: 3px;
        box-shadow: 0 0 0 4px #fff inset;
        transition: all 0.7s;
    }

    .cut,
    .create,
    .back {
        float: left;
        width: 160px;
        height: 55px;
        margin-left: 25px;
        margin-bottom: 15px;
        background-color: #5bd219;
        color: #fff;
        font-size: 20px;
        line-height: 55px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }

    .copy,
    .clear {
        float: left;
        width: 160px;
        height: 55px;
        margin-left: 20px;
        margin-bottom: 15px;
        background-color: #5bd219;
        color: #fff;
        font-size: 20px;
        line-height: 55px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }

    .save {
        position: relative;
        color: #fff;
        width: 252px;
        height: 83px;
        //padding-top: 20px;
        background: url("../assets/images/button5.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        font-size: 20px;
        font-weight: bold;
        //padding-left: 50px;
        //box-sizing: border-box;
        cursor: pointer;
        text-align: center;
        line-height: 83px;
        margin: 300px 0 0 80px;
    }

    .save img {
        width: 45px;
        position: absolute;
        left: -10px;
        bottom: 10px;
    }

    .shezhi {
        transition: all 0.7s;
    }

    .shezhistyle {
        background: #fff;
        color: #5bd219;
    }

    .create {
        position: relative;
    }

    .xinjian {
        position: absolute;
        left: 0;
        top: 0;
        width: 200px;
        height: 165px;
        border-radius: 5px;
        background-color: #EC494E;
        box-shadow: 0 0 15px rgba(236, 73, 78, 0.76);
        cursor: default;
        display: none;
    }

    .xinjian:hover {
        color: #fff;
    }

    .xinjian_before {
        position: absolute;
        right: 0;
        top: 0;
        width: 20px;
        height: 20px;
        color: #fff;
        line-height: 16px;
        text-indent: -1px;
        font-size: 30px;
        border: 1px solid #fff;
        transform: rotate(45deg);
        border-radius: 50%;
        cursor: pointer;
    }

    .xinjian h6 {
        width: 100%;
        height: 50px;
        color: #fff;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        font-weight: normal;
    }

    #ding {
        width: 60px;
        height: 30px;
        font-size: 14px;
        border-radius: 3px;
        color: #fff;
        background-color: #0078ff;
        border: 0;
        outline: none;
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0, 120, 255, 0.5);
    }

    .xinjian_width,
    .xinjian_height {
        float: left;
        width: 85px;
        height: 40px;
        margin-left: 10px;
        border-radius: 5px;
        margin-bottom: 20px;
        background-color: #FFBC00;
    }

    .xinjian_width:hover,
    .xinjian_height:hover {
        background-color: #fff;
        color: #000;
    }

    .xinjian_width span,
    .xinjian_height span {
        float: left;
        width: 30px;
        height: 100%;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
    }

    .xinjian_width input,
    .xinjian_height input {
        float: left;
        margin-top: 5px;
        width: 50px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        border: 1px solid #FFBC00;
        box-sizing: border-box;
    }

    .box {
        float: left;
        width: 160px;
        height: 55px;
        background-color: #EC494E;
        overflow: hidden;
        border-radius: 5px;
        transition: all 0.7s;
        font-size: 20px;
    }

    .box {
        margin-left: 25px;
    }

    .linewidth {
        margin-left: 20px;
    }

    .box:hover {
        background-color: #fff;
    }

    .box span {
        display: block;
        float: left;
        width: 65px;
        height: 45px;
        font-size: 18px;
        color: #fff;
        text-align: center;
        line-height: 55px;
        color: #fff;
        transition: all 0.3s;
    }

    .box input {
        float: left;
        width: 90px;
        height: 45px;
        margin-top: 5px;
        border: 1px solid #fff;
        box-sizing: border-box;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        color: #fff;
        background: #EC494E;
        border-radius: 3px;
        box-shadow: 0 0 0 4px #fff inset;
        transition: all 0.3s;
    }

    .box2 span {
        width: 55px;
    }

    .box2 input {
        width: 140px;
    }

    .space {
        float: left;
        width: 100%;
        height: 0;
        border-bottom: 1px solid #666;
        margin: 20px 0;
    }

    .right_box {
        position: fixed;
        right: 10px;
        width: 500px;
        height: 70px;
        top: 10px;
    }

    .right_box .title {
        font-weight: bold;
        font-size: 20px;
        color: #fff;
        margin: 0 0 20px 0;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .right_bottom {
        height: 915px;
        max-height: 915px;
        overflow-y: scroll;
        background: #4B4B4B;
        border-radius: 5px;
        padding: 0 20px;
    }

    .right_box .item {
        padding: 20px 0;
        border-bottom: 1px solid #666666;
        display: flex;
        align-items: flex-start;
        color: #fff;
        font-size: 16px;
    }

    .right_box .item span {
        width: 35px;
        margin-right: 20px;
    }

    .right_box .item div div {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .right_box .item div div:last-child {
        margin: 0;
    }

    .right_box .item div input {
        width: 20px;
        height: 20px;
        margin: 0 10px 0 0;
    }

    .right_box .btns {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .right_box .btns a {
        text-decoration: none;
        width: 150px;
        height: 45px;
        line-height: 45px;
        text-align: center;
        background: #20BE18;
        border-radius: 5px;
        color: #fff;
        font-size: 20px;
    }
}

.submitButton{
    width: 221px;
    height: 72px;
    background: linear-gradient(180deg, #8FD7FE 0%, #15B2FC 100%);
    border-radius: 36px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 72px;
    position: absolute;
    right: 150px;
    bottom: 200px;
}
// 取消默认外边框虚线
.vdr.active:before {
    display:none;
}
.topic_53_box {
    .options-judgment-box53 {
        width: 450px;
        height: 480px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        position: absolute;
        left: 200px;
        top: 150px;
    }
    .image_53_back {
        position: absolute;
        right: 250px;
        top: 250px;
    }
    .type58Box {
        width: 320px;
        max-height: 500px;
        min-height: 300px;
        padding: 40px;
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 0px rgba(205,205,205,0.3);
        border-radius: 30px;
        position: absolute;
        right: 80px;
        bottom: 300px;
    }
    .option_button {
        position: absolute;
        right: 80px;
        bottom: 150px;
        ::v-deep .el-radio__input.is-checked + .el-radio__label{
            color: #F76664!important;

        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner {
            border-color: #F76664!important;
            background-color: #F76664!important;
        }
        .el-radio-group {
            width: 580px;
            flex-wrap: nowrap;
            display: flex;
            .el-radio {
                width: 222px;
                height: 78px;
                line-height: 78px;
                background: linear-gradient(180deg, #8FD7FE 0%, #15B2FC 100%);
                box-shadow: 0px 6px 0px 0px #069BEF;
                border-radius: 34px 35px 35px 34px;
                margin-right: 0;
                margin-left: 70px;
                margin-bottom: 10px;
                font-size: 25px;
                font-weight: bold;
                color: #FFFFFF;
                display: flex;
                justify-content: center;
            }
        }

    }
}

.options-list {
    width: 100%;
    //height: 530px;
    margin-top: 20px;
    font-size: 20px;
}

.options52_box {
    margin: 0 auto;
    margin-top: 80px;
    width: 800px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .options52_box_child {
        width: 180px;
        height: 180px;
        //background: #D3D3D3;
        border-radius: 2px;
        margin-bottom: 35px;
    }

}
.option_button {
    display: flex;
    float: right;
    margin-right: 100px;
    .prev {
        background: linear-gradient(180deg, #8FD7FE 0%, #15B2FC 100%);
        box-shadow: 0px 6px 0px 0px #069BEF;
        border-radius: 34px 35px 35px 34px;
        margin-left: 70px;
    }
}
.image_box_none {
    width: 333px;
    height: 202px;
}
.image_box {
    width: 333px;
    height: 202px;
    background: #FFFFFF;
    line-height: 202px;
    text-align: center;
    font-size: 50px;
    font-weight: bold;
    border: 1px solid #979797;
}
.options-img-judgment_answer {
    display: block;
    //width: 333px;
    height: 304px;
    margin: 120px auto;

}

.options-judgment-box {
    width: 100%;
    .options-img-judgment {
        display: block;
        //width: 333px;
        height: 304px;
        margin: 120px auto;
    }
    .options-judgment-box-answer {
        margin: 0 auto;
        //margin-top: 100px;
        display: flex;
        justify-content: space-around;
    }
    .answerQuestions_image {
        width: 333px;
        height: 201px;
        position: absolute;
        top: 120px;
        left: 0;
        z-index: 1;
    }
}
::v-deep {
    .el-radio-group {
        width: 100%;
        //display: flex;
        //flex-wrap: wrap;
        //align-items: flex-start;
    }
    .el-radio {
        //width: 48%;
        display: flex;
        align-items: center;
        color: #000000;
        margin-bottom: 25px;
        white-space: pre-wrap;
        font-size: inherit;
        line-height: 30px;
    }

    .el-radio__label {
        font-size: inherit !important;
    }
}
::v-deep .el-checkbox__label {
    margin-bottom: 40px;
    color: #333333;
    font-weight: 500;
    font-size: 22px !important;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    font-weight: 500;
    font-size: 22px;
    color: #15B2FC;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #15B2FC;
    background: #15B2FC;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #15B2FC;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #15B2FC;
    background: #15B2FC;
}
.segment_list {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .segment {
        margin-left: -300px;
        display: flex;
        position: absolute;
        .line_text {
            width: 100px;
            text-align: center;
            font-size: 20px;
            color: #999999;
            position: relative;
            top: 10px;
            left: 50%;
            cursor: pointer;
        }
        .line_box {
            width: 100px;
            height: 10px;
            border: 1px solid #999999;
            border-top: none;
        }
        .extend1 {
            width: 120px;
            text-align: center;
            position: relative;
            top: -50px;
            left: 13%;
            font-size: 24px;
        }
        .extend2 {
            width: 120px;
            text-align: center;
            position: relative;
            top: -50px;
            left: 87%;
            font-size: 24px;
        }
    }
}
.terminal-bg-zdy {
    width: 100vw;
    height: 100vh;
    background-image: url(../assets/images/zdy.png);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    //padding: 77px 161px;
    overflow-y: scroll;
    .zdyText {
        font-size: 77px;
        font-weight: bold;
        color: #7DB167;
        text-align: center;
        margin-top: 80px;
    }
    .button-wrap-zdy {
        //width: 100%;
        position: absolute;
        bottom: 100px;

        //> span {
        //    position: absolute;
        //    font-size: 22px;
        //    right: 0;
        //}
        .submit-question {
            width: 263px;
            height: 83px;
            line-height: 83px;
            font-size: 25px;
            font-weight: bold;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
    }
}
.terminal-bg {
    width: 100vw;
    height: 100vh;
    background-image: url(../assets/images/login_BG.png);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    padding: 77px 161px;
    overflow-y: scroll;
}

.sheet {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -45%);
    width: 1750px;
    height: 920px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.69) 0%, #FFFFFF 100%);
    padding: 40px 80px 0;
}

.page-count {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-100%);
    font-size: 54px;
    color: #FFFFFF;
    display: flex;
    align-items: center;

    > span {
        color: #FFFFFF;
        font-size: 30px;
        margin-top: 10px;
    }

}
::v-deep .el-button > span {
    display: flex;
    justify-content: center;
    align-items: center;
}

//.submit-question {
//    background: linear-gradient(0deg, #32D25B 0%, #FA084E 0%, #FF669D 100%);
//    box-shadow: 0px 6px 0px 0px #D40A5D;
//    border-radius: 35px;
//    margin-left: 72px;
//
//    img {
//        margin-left: 10px;
//    }
//}

.button-wrap {
    // margin-top: 150px;
    // display: flex;
    // justify-content: space-around;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 40px;
    //margin: 0 265px;
    display: flex;
    //justify-content: space-around;
    .el-radio-group {
        width: 700px;
        //width: 580px;
        flex-wrap: nowrap;
        display: flex;
        .el-radio {
            width: 258px;
            height: 94px;
            line-height: 94px;
            background-image: url(../assets/images/button5.png);
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 0;
            margin-left: 70px;
            font-size: 25px;
            font-weight: bold;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
        }
    }
}
.prev {
    width: 258px;
    height: 94px;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    line-height: 94px;
    font-size: 25px;
    font-weight: bold;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        width: 28px;
        height: 28px;
    }
}
.prev1 {
    background-image: url(../assets/images/button1.png);
    img {
        margin-right: 10px;
        margin-left: 50px;
    }
}
.prev2 {
    background-image: url(../assets/images/button2.png);
    img {
        margin-right: 10px;
    }
}
.prev3 {
    background-image: url(../assets/images/button3.png);
    img {
        margin-left: 10px;
    }
}
.prev4 {
    background-image: url(../assets/images/button4.png);
    img {
        margin-left: 10px;
    }
}
.prev5 {
    background-image: url(../assets/images/button5.png);
}
.title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    color: #000000;
    line-height: 45px;
    position: relative;
    > h3 {
        font-weight: normal !important;
    }

    > h3 > span {
        position: absolute;
        left: 0;
        top: 0;
        transform: translateX(-120%);
    }
}



.radio {
    width: 100%;
}

.radio-wrap {
    display: flex;
    flex-wrap: wrap;
}

.options-wrap {
    display: flex;
    align-items: center;
}

.options-img {
    height: 400px;
    width: auto;
}

.typeface {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-100%);
    cursor: pointer;
}

.typeface img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
    margin-right: 2px;
}

.timer {
    width: 200px;
    height: 37px;
    position: absolute;
    top: -13px;
    left: 50%;
    margin-left: -100px;
    transform: translateY(-100%);
    display: flex;
}

.timer img {
    width: 37px;
    height: 38px;
}

.timer span {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 12px;
}

.input {
    display: flex;
    text-align: center;
    line-height: 50px;
    width: 270px;
    height: 50px;

    input {
        width: 180px;
        line-height: 50px;
        font-size: 18px;
        border-bottom: 1px solid #333333;
    }
}
.input_ {
    display: flex;
    text-align: center;
    line-height: 50px;
    // width: 300px;
    height: 50px;

    input {
        width: 300px;
        line-height: 50px;
        font-size: 18px;
        border-bottom: 1px solid #333333;
    }
}
</style>
